// TAGALYS UTILITIES
TagalysCustomizations = {}
TagalysCustomizations.utilities = {}
TagalysCustomizations.utilities.setConfiguration = function() {
  Tagalys.setConfiguration({
    api: {
      serverUrl: "https://api-r3.tagalys.com",
      credentials: {
        clientCode: "3D476828428E5ACA",
        apiKey: "280e1cbfbb006ea9b2eb6a43630d7571"
      },
      storeId: "32542523523"
    },
    platform: "Shopify",
    locale: "en-US",
    currency: {
      displayFormatter: "{{currencyLabel}}{{value}}",
      code: "USD",
      label: "$",
      fractionalDigits: 2,
      forceFractionalDigits: true
    },
    analyticsStorageConsentProvided: function(){
      // return true/false based on user's consent settings
      return true
    },
    track: true
  });
}

TagalysCustomizations.utilities.getVariantId = function (stringToMatch, variants) {
  let invalidExp = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g
  var words = stringToMatch.replace(invalidExp,"").replace(/\//g, " ").replace(/\s+/g, " ").split(' ');
  var variantIdToCountMap = {}
  words.forEach(function (word) {
    var regex = new RegExp(word, "gi")
    variants.forEach(function(variant) {
      var matchedStrings = variant.title.match(regex)
      if (matchedStrings) {
        if (variantIdToCountMap.hasOwnProperty(variant.id)) {
          variantIdToCountMap[variant.id] += matchedStrings.length;
        } else {
          variantIdToCountMap[variant.id] = matchedStrings.length
         }
      }
    })
  })
  var maxValue = Object.entries(variantIdToCountMap).sort((x, y) => y[1] - x[1])[0];
  return maxValue ? maxValue[0] : false
}

TagalysCustomizations.utilities.getNamespacedQuerySelector = function (namespace, productId, cssSelector) {
  return `${namespace} [data-product-id="${productId}"] ${cssSelector}`
}

TagalysCustomizations.utilities.handleOnImageError = function (event, product, namespace) {
  var variantId = event.target.dataset.variantId;
  event.target.classList.remove("swatch-active")
  var fallbackSwatchImageSelector = TagalysCustomizations.utilities.getNamespacedQuerySelector(namespace, product.id,  `[data-variant-id="${variantId}"] .fallback-swatch-image`)
  var fallbackSwatchElement = document.querySelector(fallbackSwatchImageSelector)
  fallbackSwatchElement.classList.add("swatch-active")
}

TagalysCustomizations.utilities.getPrimaryImageToDisplay = function (query, product) {
  var variantId = TagalysCustomizations.utilities.getVariantId(query, product.variants)
  if (variantId) {
    var image = product.images.find(function(image){
      return image.variant_ids.includes(parseInt(variantId))
    })
    if(image){
      return image.src
    }
  }
  var fallbackImageSrc = product.__tagalys_fields.image_url
  if(product.variants.length >= 1){
    var variantImage = product.images.find(function(image){
      return image.variant_ids.includes(product.variants[0].id)
    })
    if(variantImage){
      fallbackImageSrc = variantImage.src
    }
  }
  return fallbackImageSrc
}

TagalysCustomizations.utilities.getSwatchId = function (variantTitle) {
  return variantTitle
    .replace(/\//g, " ")
    .replace(/\s+/g, "-")
    .toLowerCase();
}

TagalysCustomizations.utilities.getFallbackSwatchColor = function (variant) {
  var swatchId = TagalysCustomizations.utilities.getSwatchId(variant.title)
  var fallbackColor = swatchId.split("-").pop()
  return fallbackColor
}

TagalysCustomizations.utilities.getSwatchImageUrl = function (variantTitle) {
  var prefix = "https://cdn.shopify.com/s/files/1/0325/4252/3523/files/color-";
  var swatchId = TagalysCustomizations.utilities.getSwatchId(variantTitle)
  var suffix = "_50x.png";
  return prefix + swatchId + suffix;
}

TagalysCustomizations.utilities.onColorSwatchMouseHover = function (event, product, namespace) {
  var variantId = event.target.dataset.variantId;
  var hasVariantImage = product.images.find((image)=>{
    return image.variant_ids.includes(parseInt(variantId))
  })

  if(hasVariantImage){
    var currentActiveImage = document.querySelector(TagalysCustomizations.utilities.getNamespacedQuerySelector(namespace, product.id, ".product-image.is-active"))
    currentActiveImage.classList.remove("is-active")
    var imageDom = document.querySelector(TagalysCustomizations.utilities.getNamespacedQuerySelector(namespace, product.id,  `[data-variant-id="${variantId}"]`));
    imageDom.classList.add("is-active")
  }else{
    TagalysCustomizations.utilities.setPrimaryImageAsActive(product, namespace)
  }
}

TagalysCustomizations.utilities.setPrimaryImageAsActive = function(product, namespace){
  var currentActiveImage = document.querySelector(TagalysCustomizations.utilities.getNamespacedQuerySelector(namespace, product.id, ".product-image.is-active"))
  currentActiveImage.classList.remove("is-active")
  var primaryImage = document.querySelector(TagalysCustomizations.utilities.getNamespacedQuerySelector(namespace, product.id, "[data-primary-image]"))
  // 3: Make it is active
  primaryImage.classList.add("is-active")
}

TagalysCustomizations.utilities.onColorSwatchMouseOut = function (event, product, namespace) {
  TagalysCustomizations.utilities.setPrimaryImageAsActive(product, namespace)
}

TagalysCustomizations.utilities.productRenderer = function (html, args, options = { query: "", namespace: "", widgetContext: "", showReviews: "", showSwatches: "", showProdFitment: "" }) {
  var show_reviews = options.showReviews;
  var show_swatches = options.showSwatches;
  var show_pfitment = options.showProdFitment;
  var props = args.props;
  var product = props.product;
  var helpers = props.helpers;
  var productLink = product.__tagalys_fields.link
  var productPrimaryImage = TagalysCustomizations.utilities.getPrimaryImageToDisplay(options.query, product)
  var isProductOnSale = product.tags.includes("sale");
  var isClicklock = product.tags.includes("_label_clicklock");
  var isMagsafe = product.tags.includes("_label_bf-magsafe");
  var isSamsung = product.tags.includes("_label_samsung");
  var isMagnet = product.tags.includes("_label_magnet");
  var isGoogle = product.tags.includes("_label_google");
  var isProductSoldOut = (product.__tagalys_fields.in_stock === false);
  var showCustomTag = (!isProductOnSale && !isProductSoldOut)
  var modelTag = product.tags.find(function (item) {
    return item.includes("model:");
  });
  var modelName = "";
  if (modelTag) {
    modelName = modelTag.split("model:").join("").trim();
  }
  var showFitment = "";
  if (show_pfitment) {
    var metafields = product.metafields;
    if ( Object.keys(metafields).length > 0 ) {
      showFitment = metafields.custom.hide_fitment.value;
    } else {
      showFitment = false;
    }    
  } else {
    showFitment = true;
  }
  
  let fitmentArr = [];
  let productFitment = [];
  
  product.tags.forEach(function (item) {
    if ( item.includes("fits:") ) {
      item = item.split("fits:").join("").trim();
      fitmentArr.push(item);
    }
  });
  if (fitmentArr.length !== 0) {
    fitmentArr.sort();
    fitmentArr.forEach(function (item) {
      item = item.split("_").slice(-1);
      productFitment.push(item);
    });
  } else {
    productFitment.push(modelName);
  }

  var productTagClasses = ["product-tag"];
  if (isProductOnSale) {
    productTagClasses.push("product-sale-label");
  }
  if (isProductSoldOut) {
    productTagClasses.push("product-sold-out-label");
  }
  if(showCustomTag){
    productTagClasses.push("product-custom-tag")
    if (isClicklock) {
      productTagClasses.push("clicklock")
    } else if (isMagsafe) {
      productTagClasses.push("bf-magsafe")
    } else if (isSamsung) {
      productTagClasses.push("samsung")
    } else if (isMagnet) {
      productTagClasses.push("magnet")
    } else if (isGoogle) {
      productTagClasses.push("google")
    }
  }
  var productTagClass = productTagClasses.join(" ");

  var imagesWithVariants = product.images.filter(function (image) {
    return image.variant_ids.length > 0;
  });

  var getProductTagTemplateName = function () {
    if(isProductSoldOut){
      return "soldOutLabel"
    }
    if(isProductOnSale){
      return "saleLabel"
    }
    if(isClicklock && showCustomTag){
      return "clicklockLabel"
    }
    if(isMagsafe && showCustomTag){
      return "magsafeLabel"
    }
    if(isSamsung && showCustomTag){
      return "samsungLabel"
    }
    if(isMagnet && showCustomTag){
      return "magnetLabel"
    }
    if(isGoogle && showCustomTag){
      return "googleLabel"
    }
    return false
  }

  var productTagTemplateName = getProductTagTemplateName()

  return html`
    <div class="product" data-product-id=${product.id} aria-label="product">
      <a
        class="product-link"
        href=${productLink}
        target="_blank"
      >
        ${productTagTemplateName ? html `
          <div class=${productTagClass}>
            <${args.templates[productTagTemplateName]}/>
          </div>
        `
        : null}
        <span class="product-image-container">
          <img
            class="product-image is-active"
            data-primary-image
            src=${productPrimaryImage}
            alt=${product.title}
          />
          ${imagesWithVariants.map(function (image) {
            var imgAlt = image.alt
            if (imgAlt && imgAlt.includes("#")) {
              var imgAltSplt = imgAlt.split("#",1)
              var cleanAlt = imgAltSplt[0]              
            } else {
              var cleanAlt = imgAlt
            }
            return html`
              <img
                data-variant-id=${image.variant_ids[0]}
                class="product-image"
                src=${image.src}
                alt="${cleanAlt}"
              />
            `;
          })}
        </span>
        <div class="product-details">
          <h3 class="product-name" dangerouslySetInnerHTML=${{ __html: product.title}}></h3>
          ${!showFitment ? html `
          <div class="product-model fitment">Fits:          
            ${productFitment ? html `
              ${productFitment.map(function (fit) {
              return html`<span>${fit}</span>`;
            })}` : null}
          </div>`
          : null}
          ${!isProductSoldOut ? html `
            <div
              class=${`product-prices${
                helpers.isProductOnSale(
                  product.compare_at_price,
                  product.price
                )
                  ? " discounted"
                  : " full-price"
              }`}
            >
              ${helpers.isProductOnSale(
                product.compare_at_price,
                product.price
              )
                ? html`
                    <div class="product-price-regular">
                      ${helpers.formatCurrency(
                        product.compare_at_price === null
                          ? product.price
                          : product.compare_at_price
                      )}
                    </div>
                    <div class="product-price-discounted">
                      ${` from `}${helpers.formatCurrency(product.price)}
                    </div>
                  `
                : html`
                    <div class="product-price-regular">
                      ${helpers.formatCurrency(
                        product.compare_at_price === null
                          ? product.price
                          : product.compare_at_price
                      )}
                    </div>
                  `}
            </div>
          ` : null}
          <!-- end_pwr_category_snippet -->
        </div>
      </a>
      ${show_reviews ? html `
      <!-- Start BazaarVoice Review Summary (Collection) -->
        <div class="grid-product__reviews">
          <div data-bv-show="inline_rating" data-bv-product-id="${product.id}" data-bv-redirect-url="${productLink}" data-bv-seo="false"></div>
        </div><!-- End BazaarVoice Review Summary (Collection) -->
        `
        : null}
      ${show_swatches ? html `
      <ul class="swatch-list">
        ${product.variants.length > 1 ? html `
          ${product.variants.map(function (variant) {
            var fallbackSwatchColor = TagalysCustomizations.utilities.getFallbackSwatchColor(variant)
            var style = { backgroundColor: fallbackSwatchColor }
            return html`<li
              onMouseEnter=${function (event) {
                TagalysCustomizations.utilities.onColorSwatchMouseHover(event, product, options.namespace);
              }}
              onMouseLeave=${function (event) {
                TagalysCustomizations.utilities.onColorSwatchMouseOut(event, product, options.namespace);
              }}
              data-variant-id=${variant.id}
            >
              <a
                class="color-swatch"
                href=${`${productLink}?variant=${variant.id}`}
                target="_blank"
                aria-label=${variant.title}
              >
                <img
                  class="swatch-active swatch"
                  data-variant-id=${variant.id}
                  src="${TagalysCustomizations.utilities.getSwatchImageUrl(variant.title)}"
                  onError=${function (event) {
                    TagalysCustomizations.utilities.handleOnImageError(event, product, options.namespace);
                  }}
                />
                <span class="swatch fallback-swatch-image" style=${style}></span>
              </a>
            </li>`;
          })}
        ` : null}
      </ul>`
        : null}        
      <!-- start_pwr_category_snippet -->
      <div class="pwr-category-snippets exclude-tagalys-css-reset"><div id=${`${options.widgetContext}-snippet-${product.id}`}></div></div>
    </div>
  `;
}

TagalysCustomizations.utilities.getPagesToDisplay = function(currentPage, totalPages, delta) {
  var current = currentPage,
      last = totalPages,
      left = current - delta,
      right = current + delta + 1,
      range = [],
      rangeWithDots = [],
      l;

  for (let i = 1; i <= last; i++) {
      if (i == 1 || i == last || i >= left && i < right) {
          range.push(i);
      }
  }

  for (let i of range) {
      if (l) {
          if (i - l === 2) {
          rangeWithDots.push({
            page: l + 1,
            current: current === (l + 1),
          });
          } else if (i - l !== 1) {
            rangeWithDots.push({
              jumpAfter: true
            })
          }
      }
      rangeWithDots.push({
        page: i,
        current: (i === current)
      });
      l = i;
  }

  return rangeWithDots;
}

TagalysCustomizations.utilities.initProductRatings = function(helpers, options = { baseSelector: "", widgetContext: ""  }){
  var apiResponse = helpers.getAPIResponse();
  window.pwr = window.pwr || function () {
    (pwr.q = pwr.q || []).push(arguments);
  };
  var json_list = [];
  var m = 0
  document.querySelectorAll(`${options.baseSelector} .pwr-category-snippets`).forEach(element => {
    element.innerHTML = `<div id="${options.widgetContext}-snippet-${apiResponse.products[m].id}"></div>`;
    m++;
  });
  for (let i = 0; i < apiResponse.products.length; i++) {
    const product = apiResponse.products[i];
    var json = {
      api_key: 'ea86d570-8331-45c7-a38b-107ca54b89b3',
      locale: 'en_US',
      merchant_group_id: '47546',
      merchant_id: '37684',
      page_id: product.id,
      components: {
        CategorySnippet: `${options.widgetContext}-snippet-${product.id}`
      }
    };
    json_list.push(json)
  }
  pwr('render', json_list);
}

// COMMON TEMPLATES
TagalysCustomizations.commonTemplates = {
  soldOutLabel: {
    render: function (html, args) {
      return html `Sold Out`;
    },
  },
  saleLabel: {
    render: function (html, args) {
      return html `Sale`;
    },
  },
  clicklockLabel: {
    render: function (html, args) {
      return html `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 400 392.73" style="enable-background:new 0 0 400 392.73;" xml:space="preserve" role="img" aria-labelledby="flagTitle_clicklock">
            <title id="flagTitle_clicklock">Built for MagSafe and ClickLock</title>
          <style type="text/css">
          	.st0__clicklock{fill:#53575A;}
          	.st1__clicklock{fill:#00A6CE;}
          </style>
          <g id="clicklock_cat_clicklock">
          	<g>
          		<g>
          			<g>
          				<path class="st0__clicklock" d="M41.72,42.15c1.81,2.33,2.71,4.98,2.71,7.97c0,4.31-1.5,7.73-4.51,10.25c-3.01,2.52-7.21,3.78-12.6,3.78
          					H3.31V12.59h23.21c5.24,0,9.34,1.21,12.31,3.6c2.96,2.4,4.43,5.66,4.43,9.77c0,3.04-0.8,5.56-2.39,7.57s-3.7,3.4-6.35,4.19
          					C37.51,38.34,39.91,39.83,41.72,42.15z M15.88,33.45h8.21c2.06,0,3.64-0.45,4.75-1.36c1.1-0.91,1.64-2.24,1.64-4
          					c0-1.76-0.55-3.11-1.64-4.04c-1.11-0.93-2.69-1.4-4.75-1.4h-8.21V33.45z M30.01,52.58c1.15-0.96,1.72-2.34,1.72-4.15
          					c0-1.81-0.6-3.23-1.8-4.26s-2.86-1.55-4.95-1.55h-9.1v11.38h9.24C27.23,54.01,28.85,53.53,30.01,52.58z"/>
          				<path class="st0__clicklock" d="M64.81,12.59v30.84c0,3.08,0.76,5.46,2.28,7.13c1.51,1.66,3.74,2.5,6.68,2.5c2.93,0,5.19-0.83,6.75-2.5
          					c1.56-1.66,2.36-4.04,2.36-7.13V12.59h12.56v30.77c0,4.6-0.98,8.49-2.95,11.68c-1.96,3.18-4.59,5.58-7.89,7.2
          					c-3.31,1.62-6.99,2.43-11.06,2.43c-4.05,0-7.69-0.8-10.9-2.39c-3.21-1.59-5.74-3.99-7.6-7.2s-2.79-7.11-2.79-11.71V12.59H64.81z
          					"/>
          				<path class="st0__clicklock" d="M119.74,12.59v51.55h-12.56V12.59H119.74z"/>
          				<path class="st0__clicklock" d="M144.35,54.45h16.44v9.69h-29.01V12.59h12.57V54.45z"/>
          				<path class="st0__clicklock" d="M203.22,12.59v10.07h-13.66v41.49H177V22.66h-13.66V12.59H203.22z"/>
          				<path class="st0__clicklock" d="M264.18,12.59v10.07h-20.99v10.87h15.71v9.77h-15.71v20.85h-12.57V12.59H264.18z"/>
          				<path class="st0__clicklock" d="M283.06,61.28c-4.04-2.25-7.25-5.39-9.62-9.43c-2.37-4.04-3.56-8.58-3.56-13.62
          					c0-5.05,1.19-9.57,3.56-13.59s5.58-7.15,9.62-9.4s8.49-3.38,13.33-3.38c4.85,0,9.3,1.13,13.33,3.38
          					c4.04,2.25,7.22,5.38,9.56,9.4c2.32,4.02,3.48,8.54,3.48,13.59c0,5.04-1.17,9.58-3.52,13.62c-2.35,4.04-5.54,7.18-9.54,9.43
          					c-4.02,2.26-8.45,3.38-13.3,3.38C291.55,64.66,287.1,63.53,283.06,61.28z M306.27,49.09c2.46-2.74,3.7-6.36,3.7-10.87
          					c0-4.56-1.24-8.19-3.7-10.91c-2.48-2.72-5.76-4.07-9.88-4.07c-4.16,0-7.47,1.34-9.95,4.04s-3.7,6.34-3.7,10.95
          					c0,4.55,1.23,8.18,3.7,10.9c2.48,2.72,5.79,4.07,9.95,4.07C300.5,53.2,303.79,51.83,306.27,49.09z"/>
          				<path class="st0__clicklock" d="M358.96,64.14l-10.73-19.46h-3v19.46h-12.57V12.59h21.08c4.05,0,7.52,0.71,10.39,2.13
          					c2.86,1.42,5.01,3.36,6.43,5.84c1.41,2.47,2.13,5.22,2.13,8.26c0,3.42-0.96,6.49-2.91,9.18c-1.93,2.69-4.79,4.6-8.55,5.72
          					l11.9,20.42H358.96z M345.23,35.8H353c2.31,0,4.03-0.56,5.19-1.69c1.15-1.13,1.72-2.72,1.72-4.77c0-1.96-0.57-3.5-1.72-4.63
          					c-1.16-1.13-2.88-1.69-5.19-1.69h-7.77V35.8z"/>
          				<path class="st0__clicklock" d="M62.25,86.22v52.04H49.57v-31.21l-11.63,31.21H27.7L16,106.98v31.29H3.31V86.22h14.98l14.61,36.03
          					l14.45-36.03H62.25z"/>
          				<path class="st0__clicklock" d="M107.86,128.86H88.45l-3.12,9.19H72.06l18.82-52.04h14.69l18.82,52.04h-13.41L107.86,128.86z M104.6,119.07
          					l-6.45-19.05l-6.37,19.05H104.6z"/>
          				<path class="st0__clicklock" d="M164.87,102.54c-0.93-1.73-2.29-3.05-4.04-3.97c-1.75-0.91-3.82-1.37-6.19-1.37c-4.11,0-7.4,1.35-9.86,4.04
          					c-2.47,2.69-3.71,6.29-3.71,10.79c0,4.79,1.3,8.54,3.9,11.23c2.59,2.7,6.16,4.04,10.71,4.04c3.11,0,5.74-0.79,7.88-2.37
          					c2.16-1.58,3.72-3.86,4.71-6.82H152.2v-9.34h27.57v11.79c-0.93,3.17-2.53,6.11-4.78,8.82c-2.25,2.72-5.11,4.92-8.57,6.59
          					c-3.46,1.68-7.36,2.52-11.71,2.52c-5.13,0-9.71-1.13-13.74-3.37c-4.03-2.25-7.17-5.38-9.42-9.38
          					c-2.25-4.01-3.37-8.57-3.37-13.71c0-5.14,1.12-9.73,3.37-13.75s5.38-7.16,9.38-9.41c4-2.25,8.57-3.38,13.71-3.38
          					c6.23,0,11.48,1.51,15.75,4.52c4.26,3.02,7.09,7.19,8.48,12.53H164.87z"/>
          				<path class="st0__clicklock" d="M199.35,136.78c-3.01-1.24-5.42-3.07-7.23-5.49c-1.8-2.42-2.76-5.34-2.86-8.75h13.49
          					c0.2,1.93,0.86,3.4,2,4.42c1.13,1.01,2.62,1.51,4.45,1.51c1.87,0,3.36-0.43,4.45-1.3c1.08-0.86,1.63-2.06,1.63-3.59
          					c0-1.28-0.43-2.35-1.3-3.19c-0.87-0.84-1.92-1.53-3.19-2.08c-1.26-0.54-3.05-1.16-5.37-1.85c-3.37-1.04-6.11-2.08-8.24-3.11
          					c-2.12-1.04-3.95-2.57-5.48-4.6c-1.54-2.03-2.3-4.67-2.3-7.93c0-4.84,1.75-8.63,5.26-11.38c3.5-2.74,8.08-4.11,13.71-4.11
          					c5.73,0,10.34,1.37,13.86,4.11c3.51,2.74,5.38,6.56,5.63,11.45h-13.71c-0.09-1.68-0.71-3-1.86-3.96
          					c-1.13-0.97-2.59-1.45-4.37-1.45c-1.53,0-2.76,0.41-3.71,1.22c-0.93,0.82-1.41,1.99-1.41,3.52c0,1.68,0.79,2.99,2.38,3.93
          					c1.58,0.94,4.04,1.95,7.41,3.04c3.36,1.13,6.09,2.22,8.19,3.26c2.11,1.04,3.92,2.55,5.45,4.52c1.53,1.98,2.3,4.52,2.3,7.64
          					c0,2.96-0.76,5.66-2.26,8.07c-1.51,2.42-3.7,4.35-6.55,5.78c-2.87,1.43-6.25,2.15-10.16,2.15
          					C205.77,138.64,202.36,138.02,199.35,136.78z"/>
          				<path class="st0__clicklock" d="M268.57,128.86h-19.43l-3.12,9.19h-13.27l18.83-52.04h14.68l18.83,52.04h-13.42L268.57,128.86z
          					 M265.31,119.07l-6.45-19.05l-6.38,19.05H265.31z"/>
          				<path class="st0__clicklock" d="M328.52,86.01v10.16h-21.19v10.97h15.86V117h-15.86v21.05h-12.69V86.01H328.52z"/>
          				<path class="st0__clicklock" d="M351.78,96.17v10.52h16.97v9.79h-16.97v11.42h19.19v10.15h-31.88V86.01h31.88v10.16H351.78z"/>
          				<path class="st0__clicklock" d="M391.09,85.91c1.12,0.65,2,1.56,2.64,2.71c0.64,1.16,0.96,2.45,0.96,3.88c0,1.43-0.32,2.72-0.96,3.86
          					c-0.64,1.14-1.52,2.04-2.64,2.7c-1.12,0.65-2.39,0.98-3.82,0.98c-1.43,0-2.71-0.32-3.84-0.98c-1.13-0.65-2.02-1.55-2.66-2.7
          					c-0.64-1.14-0.96-2.43-0.96-3.86c0-1.43,0.32-2.72,0.96-3.88c0.64-1.15,1.53-2.06,2.66-2.71c1.13-0.65,2.41-0.98,3.84-0.98
          					C388.7,84.93,389.98,85.26,391.09,85.91z M391.66,97.02c1.12-1.18,1.67-2.68,1.67-4.52c0-1.83-0.56-3.34-1.67-4.52
          					c-1.12-1.18-2.58-1.77-4.39-1.77c-1.83,0-3.31,0.59-4.43,1.77c-1.12,1.18-1.67,2.68-1.67,4.52c0,1.84,0.56,3.35,1.67,4.52
          					c1.12,1.18,2.6,1.77,4.43,1.77C389.08,98.79,390.55,98.21,391.66,97.02z M390.02,92.41c-0.35,0.42-0.84,0.69-1.47,0.81
          					l2.26,3.24l-1.92,0.03l-2.07-3.2h-0.87v3.2h-1.62v-8.1h3.5c0.83,0,1.49,0.22,1.98,0.66c0.49,0.44,0.73,1.04,0.73,1.79
          					C390.55,91.48,390.37,91.99,390.02,92.41z M385.95,91.94h1.77c0.35,0,0.64-0.09,0.87-0.26c0.23-0.18,0.34-0.44,0.34-0.79
          					c0-0.35-0.11-0.61-0.34-0.77c-0.22-0.17-0.52-0.24-0.87-0.24h-1.77V91.94z"/>
          			</g>
          		</g>
          		<g>
          			<g>
          				<g>
          					<g>
          						<path class="st0__clicklock" d="M125.6,241.05c-6.69-7.28-5.89-17.18,0.82-23.34c3.51-3.23,7.42-4.32,11.29-4.02
          							c0.48,0.02,0.91,0.27,1.24,0.63c0.68,0.74,0.63,1.97-0.11,2.66c-0.46,0.42-0.98,0.57-1.49,0.51c-2.99-0.26-6.1,0.63-8.52,2.85
          							c-5.08,4.66-5.37,12.26-0.18,17.9c5.15,5.61,12.78,6.01,17.85,1.34c2.42-2.22,3.63-5.24,3.56-8.24
          							c-0.01-0.51,0.18-1.01,0.64-1.44c0.75-0.69,1.94-0.67,2.66,0.11c0.32,0.35,0.54,0.81,0.52,1.29
          							c-0.07,3.99-1.42,7.65-4.97,10.91C142.21,248.38,132.29,248.33,125.6,241.05"/>
          						<path class="st0__clicklock" d="M163.1,227.12l-9.95-26.45c-0.37-0.99,0.12-2.15,1.2-2.56c0.99-0.37,2.17,0.16,2.55,1.15l9.43,25.09
          							l12.5-4.7c0.9-0.34,2,0.12,2.34,1.03c0.34,0.9-0.18,1.97-1.09,2.31l-14.26,5.36C164.57,228.83,163.58,228.38,163.1,227.12"/>
          						<path class="st0__clicklock" d="M189.42,221.05l-0.18-28.59c0-1.06,0.86-1.98,2.01-1.99c1.06,0,1.98,0.9,1.99,1.97l0.18,28.59
          							c0.01,1.06-0.9,1.98-1.96,1.99C190.3,223.02,189.43,222.11,189.42,221.05"/>
          						<path class="st0__clicklock" d="M204.64,206.06c3.52-9.24,12.73-12.95,21.24-9.7c4.46,1.7,7.18,4.7,8.65,8.3
          							c0.19,0.43,0.16,0.94-0.01,1.39c-0.36,0.95-1.48,1.45-2.43,1.09c-0.58-0.22-0.95-0.62-1.12-1.1c-1.1-2.79-3.29-5.18-6.36-6.35
          							c-6.44-2.46-13.37,0.68-16.1,7.84c-2.72,7.12,0.34,14.11,6.79,16.57c3.06,1.17,6.31,0.91,8.96-0.5
          							c0.45-0.24,0.99-0.29,1.57-0.07c0.95,0.36,1.47,1.43,1.09,2.43c-0.17,0.45-0.48,0.85-0.91,1.04
          							c-3.6,1.72-7.48,2.15-11.98,0.43C205.52,224.2,201.12,215.29,204.64,206.06"/>
          						<path class="st0__clicklock" d="M242.3,251.56c-0.83,0.65-2.02,0.54-2.65-0.25c-0.33-0.42-0.51-0.89-0.44-1.5l3.12-18.61l-4.68-0.43
          							l-7.17,5.62c-0.83,0.65-2.12,0.49-2.81-0.37c-0.68-0.87-0.5-2.12,0.34-2.78l22.5-17.63c0.83-0.65,2.09-0.54,2.78,0.33
          							c0.68,0.87,0.52,2.16-0.31,2.81l-11.72,9.19l21.89,1.59c0.61,0.01,1.03,0.3,1.35,0.71c0.62,0.8,0.54,2.03-0.25,2.65
          							c-0.38,0.29-0.84,0.41-1.35,0.38l-16.99-1.51l-2.95,18.6C242.9,250.84,242.64,251.29,242.3,251.56"/>
          						<path class="st0__clicklock" d="M100.79,337.84v-52.02c0-4.91,3.96-9.09,8.98-9.09c5.01,0,8.98,4.18,8.98,9.09v45.85h20.99
          							c4.28,0,7.84,3.45,7.84,7.83c0,4.39-3.55,7.83-7.84,7.83h-29.46C104.13,347.35,100.79,344,100.79,337.84"/>
          						<path class="st0__clicklock" d="M191.35,239.59c-21.31,0-37.29,14.83-37.29,36.04v72.82c0,21.2,15.98,36.03,37.29,36.03
          							s37.19-14.83,37.19-36.03v-72.82C228.54,254.42,212.66,239.59,191.35,239.59 M210.72,348.45c0,11.07-7.6,18.22-19.37,18.22
          							c-11.83,0-19.48-7.15-19.48-18.22v-72.82c0-11.07,7.64-18.22,19.48-18.22c11.77,0,19.37,7.15,19.37,18.22V348.45z"/>
          						<path class="st0__clicklock" d="M235.64,312.56c0-21.52,16.3-36.04,37.19-36.04c11.8,0,19.85,4.39,25.28,10.34
          							c1.36,1.46,2.3,3.55,2.3,5.75c0,4.59-3.86,8.46-8.56,8.46c-2.51,0-4.81-1.04-6.38-2.82c-3.03-3.55-7.52-5.85-12.64-5.85
          							c-10.86,0-18.91,8.77-18.91,20.16c0,11.38,8.04,20.16,18.91,20.16c5.12,0,9.61-2.3,12.74-5.85c1.46-1.78,3.76-2.82,6.27-2.82
          							c4.59,0,8.46,3.76,8.46,8.46c0,2.09-0.83,4.07-2.19,5.64c-5.54,5.96-13.48,10.45-25.28,10.45
          							C251.94,348.6,235.64,333.98,235.64,312.56"/>
          						<path class="st0__clicklock" d="M370.5,339.51c0,4.49-3.55,8.77-8.57,8.77c-2.82,0-5.12-1.25-6.58-2.93l-20.37-24.03l-5.02,5.75v12.12
          							c0,4.91-3.97,9.09-8.98,9.09s-8.98-4.18-8.98-9.09v-53.37c0-4.91,3.97-9.09,8.98-9.09s8.98,4.18,8.98,9.09v20.47l23.82-26.74
          							c1.67-1.88,3.86-2.82,6.27-2.82c4.91,0,8.36,4.28,8.36,8.46c0,2.19-0.73,4.18-1.98,5.54l-18.59,19.74l20.68,23.4
          							C369.76,335.34,370.5,337.32,370.5,339.51"/>
          						<path class="st0__clicklock" d="M378.35,279.26h-1.87c-0.2,0-0.41-0.21-0.41-0.45c0-0.24,0.21-0.45,0.41-0.45h4.71
          							c0.2,0,0.41,0.2,0.41,0.45c0,0.24-0.2,0.45-0.41,0.45h-1.87v6.41c0,0.24-0.21,0.45-0.48,0.45c-0.27,0-0.48-0.21-0.48-0.45
          							V279.26z M389.15,279.67l-2.46,5.68c-0.1,0.24-0.45,0.24-0.56,0l-2.46-5.68v5.99c0,0.24-0.2,0.45-0.48,0.45
          							c-0.27,0-0.48-0.21-0.48-0.45v-6.62c0-0.38,0.31-0.69,0.69-0.69h0.1c0.41,0,0.79,0.27,0.93,0.66l1.97,4.88l1.97-4.88
          							c0.14-0.38,0.52-0.66,0.93-0.66h0.1c0.38,0,0.69,0.31,0.69,0.69v6.62c0,0.24-0.21,0.45-0.48,0.45c-0.28,0-0.48-0.21-0.48-0.45
          							V279.67z"/>
          					</g>
          				</g>
          			</g>
          			<g>
          				<path class="st1__clicklock" d="M58.94,347.28l-6.42-6.23c-6.39,4.88-14.03,7.31-22.93,7.31c-5.34,0-9.98-0.87-13.93-2.62
          					c-3.95-1.75-7-4.22-9.14-7.41c-2.14-3.2-3.21-6.94-3.21-11.22c0-4.34,1.17-8.28,3.51-11.81c2.34-3.52,5.84-6.41,10.52-8.65
          					c-1.71-2.11-2.93-4.13-3.65-6.07c-0.73-1.94-1.09-4.07-1.09-6.37c0-3.3,0.86-6.29,2.57-9c1.71-2.7,4.2-4.82,7.46-6.37
          					c3.26-1.54,7.13-2.32,11.61-2.32c4.54,0,8.4,0.83,11.56,2.47c3.16,1.65,5.53,3.85,7.11,6.62c1.59,2.77,2.31,5.8,2.18,9.09H39.18
          					c0.06-1.78-0.38-3.14-1.34-4.1c-0.95-0.95-2.22-1.43-3.8-1.43c-1.59,0-2.9,0.47-3.96,1.38c-1.05,0.93-1.58,2.11-1.58,3.56
          					c0,1.38,0.45,2.83,1.34,4.34c0.89,1.52,2.29,3.26,4.2,5.24l16.89,16.5c0.13-0.33,0.31-0.72,0.55-1.18
          					c0.23-0.46,0.47-0.99,0.74-1.58l3.66-6.23h16.89l-4.74,8.59c-1.78,3.89-3.83,7.58-6.13,11.07l16.7,16.4H58.94z M42.14,330.97
          					l-15.41-14.92c-4.74,2.43-7.12,5.73-7.12,9.88c0,2.5,0.97,4.6,2.91,6.28c1.94,1.68,4.56,2.52,7.85,2.52
          					C34.8,334.73,38.72,333.48,42.14,330.97z"/>
          			</g>
          		</g>
          	</g>
          </g>
          </svg>`;
    },
  },
  magsafeLabel: {
    render: function (html, args) {
      return html `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          	 viewBox="0 0 400 148" style="enable-background:new 0 0 400 148;" xml:space="preserve" role="img" aria-labelledby="flagTitle_magsafe">
            <title id="flagTitle_magsafe">Built for MagSafe</title>
          <style type="text/css">
          	.st0__magsafe{fill:#53575A;}
          </style>
          <g id="magsafe_cat_magsafe">
          	<g>
          		<g>
          			<g>
          				<path class="st0__magsafe" d="M41.72,40.62c1.81,2.33,2.71,4.98,2.71,7.97c0,4.31-1.5,7.73-4.51,10.25c-3.01,2.52-7.21,3.78-12.6,3.78
          					H3.31V11.06h23.21c5.24,0,9.34,1.21,12.31,3.6c2.96,2.4,4.43,5.66,4.43,9.77c0,3.04-0.8,5.56-2.39,7.57s-3.7,3.4-6.35,4.19
          					C37.51,36.81,39.91,38.3,41.72,40.62z M15.88,31.92h8.21c2.06,0,3.64-0.45,4.75-1.36c1.1-0.91,1.64-2.24,1.64-4
          					c0-1.76-0.55-3.11-1.64-4.04c-1.11-0.93-2.69-1.4-4.75-1.4h-8.21V31.92z M30.01,51.05c1.15-0.96,1.72-2.34,1.72-4.15
          					c0-1.81-0.6-3.23-1.8-4.26s-2.86-1.55-4.95-1.55h-9.1v11.38h9.24C27.23,52.48,28.85,52,30.01,51.05z"/>
          				<path class="st0__magsafe" d="M64.81,11.06V41.9c0,3.08,0.76,5.46,2.28,7.13c1.51,1.66,3.74,2.5,6.68,2.5c2.93,0,5.19-0.83,6.75-2.5
          					s2.36-4.04,2.36-7.13V11.06h12.56v30.77c0,4.6-0.98,8.49-2.95,11.68c-1.96,3.18-4.59,5.58-7.89,7.2
          					c-3.31,1.62-6.99,2.43-11.06,2.43c-4.05,0-7.69-0.8-10.9-2.39s-5.74-3.99-7.6-7.2c-1.86-3.21-2.79-7.11-2.79-11.71V11.06H64.81z
          					"/>
          				<path class="st0__magsafe" d="M119.74,11.06v51.55h-12.56V11.06H119.74z"/>
          				<path class="st0__magsafe" d="M144.35,52.92h16.44v9.69h-29.01V11.06h12.57V52.92z"/>
          				<path class="st0__magsafe" d="M203.22,11.06v10.07h-13.66v41.49H177V21.13h-13.66V11.06H203.22z"/>
          				<path class="st0__magsafe" d="M264.18,11.06v10.07h-20.99v10.87h15.71v9.77h-15.71v20.85h-12.57V11.06H264.18z"/>
          				<path class="st0__magsafe" d="M283.06,59.75c-4.04-2.25-7.25-5.39-9.62-9.43c-2.37-4.04-3.56-8.58-3.56-13.62
          					c0-5.05,1.19-9.57,3.56-13.59s5.58-7.15,9.62-9.4s8.49-3.38,13.33-3.38c4.85,0,9.3,1.13,13.33,3.38
          					c4.04,2.25,7.22,5.38,9.56,9.4c2.32,4.02,3.48,8.54,3.48,13.59c0,5.04-1.17,9.58-3.52,13.62c-2.35,4.04-5.54,7.18-9.54,9.43
          					c-4.02,2.26-8.45,3.38-13.3,3.38C291.55,63.13,287.1,62,283.06,59.75z M306.27,47.56c2.46-2.74,3.7-6.36,3.7-10.87
          					c0-4.56-1.24-8.19-3.7-10.91c-2.48-2.72-5.76-4.07-9.88-4.07c-4.16,0-7.47,1.34-9.95,4.04s-3.7,6.34-3.7,10.95
          					c0,4.55,1.23,8.18,3.7,10.9c2.48,2.72,5.79,4.07,9.95,4.07C300.5,51.67,303.79,50.3,306.27,47.56z"/>
          				<path class="st0__magsafe" d="M358.96,62.61l-10.73-19.46h-3v19.46h-12.57V11.06h21.08c4.05,0,7.52,0.71,10.39,2.13
          					c2.86,1.42,5.01,3.36,6.43,5.84c1.41,2.47,2.13,5.22,2.13,8.26c0,3.42-0.96,6.49-2.91,9.18c-1.93,2.69-4.79,4.6-8.55,5.72
          					l11.9,20.42H358.96z M345.23,34.27H353c2.31,0,4.03-0.56,5.19-1.69c1.15-1.13,1.72-2.72,1.72-4.77c0-1.96-0.57-3.5-1.72-4.63
          					c-1.16-1.13-2.88-1.69-5.19-1.69h-7.77V34.27z"/>
          				<path class="st0__magsafe" d="M62.25,84.69v52.04H49.57v-31.21l-11.63,31.21H27.7L16,105.45v31.29H3.31V84.69h14.98l14.61,36.03
          					l14.45-36.03H62.25z"/>
          				<path class="st0__magsafe" d="M107.86,127.33H88.45l-3.12,9.19H72.06l18.82-52.04h14.69l18.82,52.04h-13.41L107.86,127.33z M104.6,117.54
          					l-6.45-19.05l-6.37,19.05H104.6z"/>
          				<path class="st0__magsafe" d="M164.87,101.01c-0.93-1.73-2.29-3.05-4.04-3.97c-1.75-0.91-3.82-1.37-6.19-1.37c-4.11,0-7.4,1.35-9.86,4.04
          					c-2.47,2.69-3.71,6.29-3.71,10.79c0,4.79,1.3,8.54,3.9,11.23c2.59,2.7,6.16,4.04,10.71,4.04c3.11,0,5.74-0.79,7.88-2.37
          					c2.16-1.58,3.72-3.86,4.71-6.82H152.2v-9.34h27.57v11.79c-0.93,3.17-2.53,6.11-4.78,8.82s-5.11,4.92-8.57,6.59
          					s-7.36,2.52-11.71,2.52c-5.13,0-9.71-1.13-13.74-3.37c-4.03-2.25-7.17-5.38-9.42-9.38c-2.25-4.01-3.37-8.57-3.37-13.71
          					s1.12-9.73,3.37-13.75s5.38-7.16,9.38-9.41c4-2.25,8.57-3.38,13.71-3.38c6.23,0,11.48,1.51,15.75,4.52
          					c4.26,3.02,7.09,7.19,8.48,12.53H164.87z"/>
          				<path class="st0__magsafe" d="M199.35,135.25c-3.01-1.24-5.42-3.07-7.23-5.49c-1.8-2.42-2.76-5.34-2.86-8.75h13.49
          					c0.2,1.93,0.86,3.4,2,4.42c1.13,1.01,2.62,1.51,4.45,1.51c1.87,0,3.36-0.43,4.45-1.3c1.08-0.86,1.63-2.06,1.63-3.59
          					c0-1.28-0.43-2.35-1.3-3.19c-0.87-0.84-1.92-1.53-3.19-2.08c-1.26-0.54-3.05-1.16-5.37-1.85c-3.37-1.04-6.11-2.08-8.24-3.11
          					c-2.12-1.04-3.95-2.57-5.48-4.6c-1.54-2.03-2.3-4.67-2.3-7.93c0-4.84,1.75-8.63,5.26-11.38c3.5-2.74,8.08-4.11,13.71-4.11
          					c5.73,0,10.34,1.37,13.86,4.11c3.51,2.74,5.38,6.56,5.63,11.45h-13.71c-0.09-1.68-0.71-3-1.86-3.96
          					c-1.13-0.97-2.59-1.45-4.37-1.45c-1.53,0-2.76,0.41-3.71,1.22c-0.93,0.82-1.41,1.99-1.41,3.52c0,1.68,0.79,2.99,2.38,3.93
          					c1.58,0.94,4.04,1.95,7.41,3.04c3.36,1.13,6.09,2.22,8.19,3.26c2.11,1.04,3.92,2.55,5.45,4.52c1.53,1.98,2.3,4.52,2.3,7.64
          					c0,2.96-0.76,5.66-2.26,8.07c-1.51,2.42-3.7,4.35-6.55,5.78c-2.87,1.43-6.25,2.15-10.16,2.15
          					C205.77,137.11,202.36,136.49,199.35,135.25z"/>
          				<path class="st0__magsafe" d="M268.57,127.33h-19.43l-3.12,9.19h-13.27l18.83-52.04h14.68l18.83,52.04h-13.42L268.57,127.33z
          					 M265.31,117.54l-6.45-19.05l-6.38,19.05H265.31z"/>
          				<path class="st0__magsafe" d="M328.52,84.48v10.16h-21.19v10.97h15.86v9.86h-15.86v21.05h-12.69V84.48H328.52z"/>
          				<path class="st0__magsafe" d="M351.78,94.64v10.52h16.97v9.79h-16.97v11.42h19.19v10.15h-31.88V84.48h31.88v10.16H351.78z"/>
          				<path class="st0__magsafe" d="M391.09,84.38c1.12,0.65,2,1.56,2.64,2.71c0.64,1.16,0.96,2.45,0.96,3.88c0,1.43-0.32,2.72-0.96,3.86
          					c-0.64,1.14-1.52,2.04-2.64,2.7c-1.12,0.65-2.39,0.98-3.82,0.98c-1.43,0-2.71-0.32-3.84-0.98c-1.13-0.65-2.02-1.55-2.66-2.7
          					c-0.64-1.14-0.96-2.43-0.96-3.86c0-1.43,0.32-2.72,0.96-3.88c0.64-1.15,1.53-2.06,2.66-2.71s2.41-0.98,3.84-0.98
          					C388.7,83.4,389.98,83.73,391.09,84.38z M391.66,95.49c1.12-1.18,1.67-2.68,1.67-4.52c0-1.83-0.56-3.34-1.67-4.52
          					c-1.12-1.18-2.58-1.77-4.39-1.77c-1.83,0-3.31,0.59-4.43,1.77c-1.12,1.18-1.67,2.68-1.67,4.52c0,1.84,0.56,3.35,1.67,4.52
          					c1.12,1.18,2.6,1.77,4.43,1.77C389.08,97.26,390.55,96.68,391.66,95.49z M390.02,90.88c-0.35,0.42-0.84,0.69-1.47,0.81
          					l2.26,3.24l-1.92,0.03l-2.07-3.2h-0.87v3.2h-1.62v-8.1h3.5c0.83,0,1.49,0.22,1.98,0.66c0.49,0.44,0.73,1.04,0.73,1.79
          					C390.55,89.95,390.37,90.46,390.02,90.88z M385.95,90.41h1.77c0.35,0,0.64-0.09,0.87-0.26c0.23-0.18,0.34-0.44,0.34-0.79
          					c0-0.35-0.11-0.61-0.34-0.77c-0.22-0.17-0.52-0.24-0.87-0.24h-1.77V90.41z"/>
          			</g>
          		</g>
          	</g>
          </g>
          </svg>`;
    },
  },
  samsungLabel: {
    render: function (html, args) {
      return html `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        	 viewBox="0 0 400 148" style="enable-background:new 0 0 400 148;" xml:space="preserve" role="img" aria-labelledby="flagTitle_samsung">
          <title id="flagTitle_samsung">Designed for Samsung</title>
          <g id="flag_samsung_samsung">
              <g>
                  <g>
                      <g>
                          <g>
                              <path d="M109.04,67.74c0.19,2.01,0.32,4.02,0.32,6.08c0,35.74-28.69,64.67-63.75,64.67H4.92c-1.81,0-3.27-1.66-3.27-3.5
                                  v-34.31l36.6,16.65c3.31,1.51,6.76,2.22,10.17,2.22c9.36-0.01,18.34-5.37,22.45-14.43l0.96-2.12
                                  c2.73-5.97,2.94-12.66,0.63-18.83c-2.31-6.18-6.87-11.08-12.85-13.8l-17.76-8.08c-4.84-2.2-6.98-7.94-4.77-12.77l1.48-3.27
                                  c1.06-2.33,2.97-4.11,5.4-5.02c2.42-0.91,5.05-0.83,7.37,0.24L109.04,67.74z"/>
                          </g>
                          <g>
                              <path d="M57.23,98.91l0.97-2.1c1.06-2.33,1.14-4.95,0.23-7.36c-0.91-2.43-2.69-4.35-5.01-5.41l-17.76-8.09
                                  c-12.37-5.62-17.85-20.26-12.22-32.62l1.49-3.27c2.73-5.97,7.61-10.54,13.79-12.85c6.18-2.31,12.86-2.07,18.84,0.64
                                  l46.89,21.34C94.8,25.94,72.02,9.51,45.61,9.51H4.92c-1.81,0-3.27,1.66-3.27,3.51v71.2l42.82,19.49
                                  C49.3,105.9,55.03,103.75,57.23,98.91z"/>
                          </g>
                      </g>
                  </g>
                  <g>
                      <path d="M133.32,29.16h8.4c2.59,0,4.9,0.4,6.93,1.18c2.03,0.79,3.74,1.87,5.13,3.25c1.39,1.38,2.45,3.01,3.17,4.88
                          c0.72,1.87,1.08,3.91,1.08,6.1c0,2.2-0.39,4.24-1.18,6.12c-0.79,1.89-1.89,3.51-3.31,4.88c-1.42,1.37-3.12,2.44-5.09,3.23
                          c-1.97,0.79-4.13,1.18-6.46,1.18h-8.66V29.16z M139.06,34.48v20.19h2.24c1.69,0,3.21-0.25,4.56-0.76
                          c1.35-0.51,2.5-1.22,3.44-2.13c0.94-0.91,1.68-1.98,2.2-3.21c0.52-1.22,0.78-2.55,0.78-3.99c0-1.49-0.23-2.85-0.68-4.08
                          c-0.45-1.22-1.14-2.29-2.07-3.19c-0.93-0.9-2.1-1.6-3.51-2.09c-1.41-0.49-3.07-0.74-4.98-0.74H139.06z"/>
                      <path d="M172.81,60.03c-1.94,0-3.72-0.32-5.32-0.96c-1.6-0.64-2.98-1.51-4.12-2.63c-1.14-1.11-2.03-2.42-2.66-3.93
                          c-0.63-1.51-0.95-3.11-0.95-4.82c0-1.74,0.33-3.36,0.99-4.88c0.66-1.52,1.57-2.84,2.72-3.95c1.15-1.11,2.51-1.99,4.08-2.65
                          c1.56-0.65,3.24-0.98,5.05-0.98c1.83,0,3.53,0.3,5.09,0.89c1.56,0.59,2.91,1.43,4.03,2.5c1.13,1.07,2.01,2.33,2.64,3.78
                          c0.63,1.45,0.95,3.03,0.95,4.75v2.02h-20.1c0.39,1.75,1.25,3.15,2.58,4.22c1.32,1.07,3,1.6,5.03,1.6c1.6,0,3-0.39,4.18-1.18
                          c1.18-0.79,2.07-1.84,2.66-3.17l4.69,2.7c-1.07,2-2.57,3.61-4.5,4.83C177.91,59.42,175.56,60.03,172.81,60.03z M172.59,40.27
                          c-1.72,0-3.2,0.38-4.46,1.14c-1.25,0.76-2.13,1.76-2.64,3h14.02c-0.42-1.36-1.24-2.39-2.45-3.09
                          C175.86,40.62,174.37,40.27,172.59,40.27z"/>
                      <path d="M197.13,60.03c-2.73,0-5-0.51-6.8-1.52c-1.8-1.02-3.2-2.49-4.18-4.41l5.28-2.37c0.59,1.08,1.39,1.91,2.41,2.49
                          c1.01,0.58,2.2,0.87,3.55,0.87c1.41,0,2.46-0.28,3.17-0.85c0.7-0.56,1.06-1.23,1.06-2.01c0-0.43-0.16-0.78-0.49-1.05
                          c-0.32-0.27-0.74-0.5-1.27-0.7c-0.52-0.2-1.13-0.37-1.84-0.5s-1.44-0.28-2.2-0.44c-1.07-0.21-2.12-0.47-3.15-0.77
                          c-1.03-0.29-1.95-0.7-2.77-1.23c-0.82-0.52-1.48-1.19-1.99-2.01c-0.51-0.82-0.76-1.84-0.76-3.08c0-0.94,0.23-1.84,0.7-2.72
                          c0.46-0.87,1.12-1.64,1.96-2.32c0.84-0.67,1.86-1.2,3.06-1.59c1.2-0.39,2.53-0.58,3.99-0.58c2.48,0,4.54,0.46,6.19,1.38
                          c1.65,0.92,2.95,2.17,3.91,3.74l-4.85,2.3c-0.51-0.83-1.21-1.48-2.11-1.96c-0.9-0.48-1.94-0.72-3.12-0.72
                          c-1.35,0-2.35,0.26-3,0.77c-0.65,0.51-0.97,1.1-0.97,1.77c0,0.78,0.48,1.34,1.43,1.67c0.96,0.34,2.37,0.69,4.22,1.07
                          c1.01,0.19,2.04,0.44,3.06,0.74c1.03,0.31,1.96,0.73,2.81,1.25c0.84,0.52,1.53,1.19,2.05,2.01c0.52,0.82,0.78,1.85,0.78,3.08
                          c0,0.83-0.2,1.7-0.59,2.6c-0.4,0.9-1.01,1.73-1.84,2.5c-0.83,0.77-1.88,1.39-3.15,1.87C200.42,59.79,198.9,60.03,197.13,60.03z"
                          />
                      <path d="M209,29.24c0-1.07,0.32-1.94,0.97-2.6c0.65-0.66,1.52-0.99,2.62-0.99c1.13,0,2.01,0.33,2.64,0.99
                          c0.63,0.66,0.95,1.53,0.95,2.6s-0.32,1.93-0.95,2.58c-0.63,0.65-1.51,0.97-2.64,0.97c-1.15,0-2.04-0.32-2.66-0.97
                          C209.31,31.17,209,30.31,209,29.24z M209.71,35.28h5.74v24.7h-5.74V35.28z"/>
                      <path d="M238.18,56.23c-0.9,1.18-2.05,2.11-3.46,2.79c-1.41,0.68-2.94,1.01-4.6,1.01c-1.49,0-2.96-0.28-4.41-0.83
                          c-1.45-0.56-2.75-1.36-3.91-2.42c-1.15-1.06-2.08-2.35-2.79-3.89c-0.7-1.53-1.06-3.28-1.06-5.23c0-1.98,0.34-3.74,1.03-5.27
                          c0.69-1.53,1.6-2.83,2.74-3.89c1.14-1.06,2.45-1.86,3.93-2.42c1.48-0.56,2.99-0.83,4.54-0.83c1.63,0,3.14,0.32,4.52,0.95
                          c1.38,0.64,2.52,1.5,3.42,2.58v-3.49h5.7v23.77c0,1.72-0.28,3.34-0.82,4.84c-0.55,1.5-1.36,2.81-2.43,3.94
                          c-1.07,1.13-2.4,2.02-3.99,2.67c-1.59,0.65-3.43,0.98-5.51,0.98c-1.6,0-3.06-0.18-4.37-0.53c-1.31-0.35-2.49-0.85-3.53-1.48
                          c-1.04-0.63-1.96-1.38-2.75-2.24c-0.79-0.86-1.46-1.81-2.03-2.85l5.07-3.08c0.9,1.66,1.91,2.9,3.04,3.72
                          c1.13,0.82,2.67,1.23,4.65,1.23c1.07,0,2.04-0.2,2.91-0.59c0.87-0.39,1.61-0.91,2.22-1.56c0.61-0.65,1.07-1.41,1.39-2.28
                          c0.32-0.87,0.49-1.77,0.49-2.7V56.23z M231.04,54.79c1.07,0,2.05-0.19,2.96-0.56s1.68-0.89,2.32-1.55
                          c0.65-0.66,1.16-1.43,1.54-2.3c0.38-0.87,0.57-1.81,0.57-2.82c0-0.98-0.19-1.9-0.57-2.78c-0.38-0.87-0.89-1.63-1.54-2.28
                          c-0.65-0.65-1.42-1.16-2.32-1.53c-0.9-0.37-1.89-0.56-2.96-0.56c-1.04,0-2.02,0.19-2.93,0.56c-0.92,0.37-1.71,0.87-2.39,1.51
                          c-0.68,0.63-1.2,1.39-1.58,2.26c-0.38,0.87-0.57,1.81-0.57,2.82c0,1.01,0.19,1.95,0.57,2.84s0.91,1.65,1.58,2.3
                          c0.68,0.65,1.47,1.16,2.39,1.53C229.02,54.61,230,54.79,231.04,54.79z"/>
                      <path d="M247.38,35.28h5.66v3.37c0.82-1.03,1.85-1.86,3.1-2.48c1.25-0.62,2.68-0.94,4.29-0.94c3.07,0,5.47,0.91,7.2,2.74
                          c1.73,1.82,2.6,4.37,2.6,7.63v14.38h-5.79V46.25c0-1.87-0.46-3.35-1.39-4.44c-0.93-1.09-2.32-1.63-4.18-1.63
                          c-1.63,0-3.01,0.56-4.12,1.69c-1.11,1.13-1.67,2.75-1.67,4.87v13.25h-5.7V35.28z"/>
                      <path d="M285.77,60.03c-1.94,0-3.72-0.32-5.32-0.96c-1.6-0.64-2.98-1.51-4.12-2.63s-2.03-2.42-2.66-3.93
                          c-0.63-1.51-0.95-3.11-0.95-4.82c0-1.74,0.33-3.36,0.99-4.88c0.66-1.52,1.57-2.84,2.72-3.95c1.15-1.11,2.51-1.99,4.08-2.65
                          c1.56-0.65,3.24-0.98,5.05-0.98c1.83,0,3.53,0.3,5.09,0.89c1.56,0.59,2.91,1.43,4.03,2.5c1.13,1.07,2.01,2.33,2.64,3.78
                          c0.63,1.45,0.95,3.03,0.95,4.75v2.02h-20.1c0.39,1.75,1.25,3.15,2.58,4.22s3,1.6,5.03,1.6c1.6,0,3-0.39,4.18-1.18
                          c1.18-0.79,2.07-1.84,2.66-3.17l4.69,2.7c-1.07,2-2.57,3.61-4.5,4.83C290.87,59.42,288.53,60.03,285.77,60.03z M285.56,40.27
                          c-1.72,0-3.2,0.38-4.46,1.14c-1.25,0.76-2.13,1.76-2.64,3h14.02c-0.42-1.36-1.24-2.39-2.45-3.09
                          C288.82,40.62,287.33,40.27,285.56,40.27z"/>
                      <path d="M312.16,60.03c-1.49,0-2.96-0.28-4.41-0.83c-1.45-0.56-2.75-1.36-3.91-2.42c-1.15-1.06-2.08-2.35-2.79-3.89
                          c-0.7-1.53-1.06-3.28-1.06-5.23c0-1.98,0.34-3.74,1.03-5.27c0.69-1.53,1.6-2.83,2.74-3.89c1.14-1.06,2.45-1.86,3.93-2.42
                          c1.48-0.56,2.99-0.83,4.54-0.83c1.6,0,3.1,0.3,4.48,0.91c1.38,0.61,2.52,1.44,3.42,2.51v-9.92h5.74v31.25h-5.7v-3.51
                          c-0.9,1.1-2.05,1.97-3.46,2.6C315.31,59.71,313.79,60.03,312.16,60.03z M313.09,54.79c1.07,0,2.05-0.19,2.96-0.56
                          s1.68-0.89,2.32-1.55c0.65-0.66,1.16-1.43,1.54-2.3c0.38-0.87,0.57-1.81,0.57-2.82c0-0.98-0.19-1.9-0.57-2.78
                          c-0.38-0.87-0.89-1.63-1.54-2.28c-0.65-0.65-1.42-1.16-2.32-1.53c-0.9-0.37-1.89-0.56-2.96-0.56c-1.04,0-2.02,0.19-2.93,0.56
                          c-0.92,0.37-1.71,0.87-2.39,1.51c-0.68,0.63-1.2,1.39-1.58,2.26c-0.38,0.87-0.57,1.81-0.57,2.82c0,1.01,0.19,1.95,0.57,2.84
                          c0.38,0.89,0.91,1.65,1.58,2.3c0.68,0.65,1.47,1.16,2.39,1.53C311.07,54.61,312.05,54.79,313.09,54.79z"/>
                      <path d="M338.55,35.28h4.18v-0.04c0-1.77,0.19-3.29,0.57-4.54c0.38-1.25,0.98-2.27,1.79-3.06c0.82-0.79,1.88-1.37,3.19-1.73
                          c1.31-0.37,2.91-0.55,4.79-0.55h0.51v5.28c-1.13,0-2.03,0.07-2.7,0.21c-0.68,0.14-1.19,0.39-1.54,0.76s-0.58,0.84-0.68,1.43
                          c-0.1,0.59-0.15,1.34-0.15,2.24h5.07v5.11h-5.07v19.6h-5.78v-19.6h-4.18V35.28z"/>
                      <path d="M366.72,60.03c-1.77,0-3.44-0.32-5-0.96c-1.56-0.64-2.92-1.52-4.08-2.65c-1.15-1.13-2.06-2.44-2.72-3.95
                          c-0.66-1.51-0.99-3.11-0.99-4.82c0-1.74,0.33-3.36,0.99-4.86c0.66-1.51,1.57-2.82,2.72-3.95c1.15-1.13,2.51-2.01,4.08-2.65
                          c1.56-0.64,3.23-0.96,5-0.96c1.77,0,3.43,0.32,4.98,0.96c1.55,0.64,2.91,1.52,4.08,2.65c1.17,1.13,2.08,2.44,2.74,3.95
                          c0.66,1.51,0.99,3.13,0.99,4.86c0,1.71-0.33,3.32-0.99,4.82c-0.66,1.51-1.58,2.82-2.74,3.95c-1.17,1.13-2.53,2.01-4.08,2.65
                          C370.16,59.71,368.5,60.03,366.72,60.03z M366.72,54.67c1.01,0,1.96-0.18,2.83-0.55c0.87-0.37,1.63-0.87,2.28-1.51
                          c0.65-0.63,1.15-1.38,1.52-2.24c0.37-0.86,0.55-1.76,0.55-2.71c0-0.98-0.18-1.89-0.55-2.75c-0.37-0.86-0.87-1.6-1.52-2.24
                          c-0.65-0.63-1.41-1.14-2.28-1.51c-0.87-0.37-1.82-0.56-2.83-0.56c-1.01,0-1.96,0.19-2.85,0.56c-0.89,0.37-1.65,0.87-2.28,1.51
                          c-0.63,0.63-1.13,1.38-1.5,2.24c-0.37,0.86-0.55,1.78-0.55,2.75c0,0.95,0.18,1.85,0.55,2.71c0.37,0.86,0.87,1.6,1.5,2.24
                          c0.63,0.63,1.39,1.14,2.28,1.51C364.76,54.48,365.71,54.67,366.72,54.67z"/>
                      <path d="M382.01,35.28h5.66v3.67c1.15-2.45,3.27-3.67,6.34-3.67c0.9,0,1.71,0.1,2.43,0.29c0.72,0.2,1.36,0.45,1.92,0.76
                          l-2.15,5.4c-0.42-0.28-0.89-0.51-1.41-0.7c-0.52-0.18-1.19-0.27-2.01-0.27c-1.66,0-2.92,0.47-3.78,1.41
                          c-0.86,0.94-1.29,2.49-1.29,4.62v13.18h-5.7V35.28z"/>
                      <path d="M146.53,116.18c-3.69,0-6.8-0.7-9.33-2.09c-2.53-1.4-4.73-3.14-6.59-5.22l6.93-5.22c1.04,1.7,2.33,3.01,3.86,3.92
                          c1.53,0.91,3.22,1.36,5.09,1.36c2.01,0,3.55-0.54,4.61-1.63c1.06-1.09,1.59-2.32,1.59-3.69c0-0.83-0.24-1.54-0.73-2.12
                          c-0.49-0.58-1.12-1.08-1.9-1.49c-0.78-0.42-1.69-0.79-2.71-1.11c-1.02-0.33-2.08-0.65-3.16-0.98c-1.38-0.43-2.76-0.9-4.13-1.41
                          c-1.38-0.51-2.62-1.18-3.72-2.04c-1.1-0.85-1.99-1.9-2.68-3.15c-0.69-1.25-1.03-2.81-1.03-4.69c0-1.59,0.33-3.08,1.01-4.45
                          c0.67-1.38,1.61-2.58,2.82-3.61c1.21-1.03,2.65-1.84,4.3-2.41c1.66-0.58,3.46-0.87,5.39-0.87c1.64,0,3.12,0.15,4.44,0.45
                          c1.32,0.3,2.53,0.71,3.63,1.23c1.1,0.52,2.1,1.15,3.02,1.87c0.91,0.73,1.78,1.52,2.6,2.37l-6.26,4.87
                          c-1.75-2.69-4.21-4.03-7.38-4.03c-1.86,0-3.28,0.44-4.25,1.3c-0.97,0.87-1.45,1.94-1.45,3.2c0,0.8,0.22,1.47,0.67,2.01
                          c0.45,0.54,1.05,1.02,1.82,1.44c0.76,0.42,1.65,0.79,2.66,1.11c1.01,0.33,2.07,0.67,3.19,1.03c1.38,0.43,2.77,0.93,4.16,1.49
                          c1.4,0.56,2.66,1.29,3.8,2.17c1.14,0.89,2.06,1.97,2.77,3.26c0.71,1.29,1.06,2.89,1.06,4.8c0,1.56-0.32,3.08-0.95,4.56
                          c-0.63,1.48-1.55,2.8-2.74,3.94c-1.19,1.14-2.66,2.06-4.42,2.77C150.76,115.83,148.76,116.18,146.53,116.18z"/>
                      <path d="M178.56,116.18c-1.98,0-3.92-0.37-5.84-1.1c-1.92-0.74-3.64-1.8-5.17-3.21c-1.53-1.4-2.76-3.11-3.69-5.15
                          c-0.93-2.03-1.4-4.34-1.4-6.92c0-2.62,0.46-4.95,1.37-6.98c0.91-2.03,2.12-3.75,3.63-5.15c1.51-1.4,3.24-2.47,5.2-3.2
                          c1.96-0.74,3.96-1.1,6.01-1.1c2.16,0,4.15,0.39,5.98,1.17c1.82,0.78,3.33,1.85,4.53,3.2v-4.31h7.55v32.7h-7.55v-4.65
                          c-1.19,1.46-2.72,2.61-4.58,3.45C182.73,115.77,180.72,116.18,178.56,116.18z M179.79,109.25c1.42,0,2.72-0.24,3.91-0.73
                          s2.22-1.17,3.07-2.05c0.86-0.87,1.54-1.89,2.04-3.04c0.5-1.15,0.75-2.4,0.75-3.73c0-1.29-0.25-2.52-0.75-3.67
                          c-0.5-1.15-1.18-2.16-2.04-3.02c-0.86-0.86-1.88-1.53-3.07-2.02s-2.5-0.74-3.91-0.74c-1.38,0-2.67,0.25-3.89,0.74
                          c-1.21,0.49-2.26,1.15-3.16,2c-0.9,0.84-1.59,1.84-2.1,2.99c-0.5,1.16-0.76,2.4-0.76,3.73c0,1.33,0.25,2.58,0.76,3.75
                          c0.5,1.17,1.2,2.19,2.1,3.04c0.89,0.86,1.95,1.53,3.16,2.02C177.11,109.01,178.41,109.25,179.79,109.25z"/>
                      <path d="M201.78,83.43h7.49v4.22c1.04-1.32,2.36-2.36,3.94-3.13c1.58-0.77,3.38-1.15,5.39-1.15c2.57,0,4.74,0.49,6.51,1.46
                          c1.77,0.97,3.14,2.34,4.11,4.1c1.12-1.69,2.6-3.04,4.44-4.05c1.84-1.01,3.94-1.51,6.29-1.51c4.4,0,7.71,1.2,9.95,3.59
                          c2.24,2.4,3.35,5.68,3.35,9.85v19.31h-7.71V97.51c0-2.33-0.6-4.18-1.79-5.54c-1.19-1.36-2.96-2.05-5.31-2.05
                          c-2.05,0-3.76,0.69-5.14,2.08c-1.38,1.38-2.07,3.48-2.07,6.28v17.86h-7.66V97.29c0-2.29-0.58-4.1-1.73-5.41
                          c-1.16-1.31-2.87-1.97-5.14-1.97c-2.12,0-3.88,0.71-5.28,2.13c-1.4,1.42-2.1,3.55-2.1,6.39v17.69h-7.55V83.43z"/>
                      <path d="M270.21,116.18c-3.61,0-6.62-0.67-9-2.02c-2.38-1.35-4.23-3.29-5.53-5.83l6.99-3.14c0.78,1.43,1.84,2.53,3.19,3.3
                          c1.34,0.77,2.91,1.15,4.7,1.15c1.86,0,3.26-0.37,4.19-1.12c0.93-0.74,1.4-1.63,1.4-2.66c0-0.57-0.21-1.03-0.64-1.39
                          s-0.99-0.67-1.68-0.93c-0.69-0.27-1.5-0.49-2.43-0.67c-0.93-0.18-1.9-0.37-2.91-0.59c-1.42-0.28-2.8-0.62-4.16-1.01
                          c-1.36-0.39-2.58-0.93-3.66-1.63c-1.08-0.69-1.96-1.58-2.63-2.66c-0.67-1.08-1.01-2.44-1.01-4.08c0-1.24,0.31-2.44,0.92-3.6
                          c0.61-1.15,1.48-2.17,2.6-3.06c1.12-0.89,2.47-1.59,4.05-2.11c1.58-0.51,3.34-0.77,5.28-0.77c3.28,0,6.01,0.61,8.19,1.82
                          c2.18,1.21,3.9,2.87,5.17,4.96l-6.43,3.04c-0.67-1.1-1.6-1.96-2.79-2.6s-2.57-0.96-4.14-0.96c-1.79,0-3.11,0.34-3.97,1.01
                          c-0.86,0.68-1.29,1.46-1.29,2.35c0,1.03,0.63,1.77,1.9,2.21c1.27,0.44,3.13,0.92,5.59,1.41c1.34,0.25,2.69,0.58,4.05,0.99
                          c1.36,0.41,2.6,0.96,3.72,1.65c1.12,0.69,2.02,1.58,2.71,2.66c0.69,1.08,1.03,2.44,1.03,4.08c0,1.1-0.26,2.25-0.78,3.44
                          c-0.52,1.19-1.33,2.29-2.43,3.31c-1.1,1.01-2.49,1.84-4.16,2.48C274.57,115.87,272.56,116.18,270.21,116.18z"/>
                      <path d="M316.22,116.13h-7.49v-4.1c-1.04,1.3-2.35,2.31-3.91,3.05c-1.56,0.74-3.39,1.1-5.48,1.1c-3.88,0-6.94-1.21-9.19-3.62
                          c-2.25-2.41-3.38-5.78-3.38-10.1V83.43h7.66v18.19c0,2.48,0.57,4.43,1.71,5.87c1.14,1.44,2.9,2.16,5.28,2.16
                          c2.09,0,3.82-0.75,5.2-2.24c1.38-1.49,2.07-3.64,2.07-6.44V83.43h7.55V116.13z"/>
                      <path d="M321.33,83.43h7.49v4.47c1.08-1.36,2.45-2.46,4.11-3.28c1.66-0.82,3.55-1.24,5.67-1.24c4.06,0,7.24,1.21,9.53,3.62
                          c2.29,2.41,3.44,5.78,3.44,10.1v19.04h-7.66V97.94c0-2.48-0.61-4.43-1.84-5.87c-1.23-1.44-3.07-2.16-5.53-2.16
                          c-2.16,0-3.98,0.75-5.45,2.24c-1.47,1.49-2.21,3.64-2.21,6.44v17.53h-7.55V83.43z"/>
                      <path d="M381.63,111.16c-1.19,1.56-2.72,2.79-4.58,3.69c-1.86,0.89-3.89,1.34-6.09,1.34c-1.98,0-3.92-0.37-5.84-1.1
                          c-1.92-0.74-3.64-1.8-5.17-3.21c-1.53-1.4-2.76-3.11-3.69-5.15c-0.93-2.03-1.4-4.34-1.4-6.92c0-2.62,0.45-4.95,1.37-6.98
                          c0.91-2.03,2.12-3.75,3.63-5.15c1.51-1.4,3.24-2.47,5.2-3.2s3.96-1.1,6.01-1.1c2.16,0,4.15,0.42,5.98,1.26
                          c1.83,0.84,3.33,1.98,4.53,3.41v-4.62h7.55v31.46c0,2.28-0.36,4.41-1.09,6.4c-0.73,1.99-1.8,3.72-3.21,5.21
                          c-1.42,1.49-3.18,2.67-5.28,3.53c-2.11,0.86-4.54,1.3-7.29,1.3c-2.12,0-4.05-0.23-5.78-0.7c-1.73-0.47-3.29-1.12-4.67-1.96
                          c-1.38-0.84-2.59-1.83-3.63-2.96c-1.04-1.14-1.94-2.39-2.68-3.77l6.71-4.08c1.19,2.2,2.53,3.84,4.02,4.92
                          c1.49,1.08,3.54,1.62,6.15,1.62c1.42,0,2.7-0.26,3.86-0.78c1.15-0.52,2.13-1.21,2.93-2.07c0.8-0.86,1.42-1.86,1.84-3.02
                          c0.43-1.15,0.64-2.35,0.64-3.58V111.16z M372.19,109.25c1.42,0,2.72-0.24,3.91-0.73c1.19-0.49,2.22-1.17,3.07-2.05
                          c0.86-0.87,1.54-1.89,2.04-3.04c0.5-1.15,0.75-2.4,0.75-3.73c0-1.29-0.25-2.52-0.75-3.67c-0.5-1.15-1.18-2.16-2.04-3.02
                          s-1.88-1.53-3.07-2.02c-1.19-0.49-2.5-0.74-3.91-0.74c-1.38,0-2.67,0.25-3.88,0.74c-1.21,0.49-2.26,1.15-3.16,2
                          c-0.89,0.84-1.59,1.84-2.1,2.99c-0.5,1.16-0.75,2.4-0.75,3.73c0,1.33,0.25,2.58,0.75,3.75c0.5,1.17,1.2,2.19,2.1,3.04
                          c0.9,0.86,1.95,1.53,3.16,2.02C369.51,109.01,370.81,109.25,372.19,109.25z"/>
                  </g>
              </g>
          </g>
        </svg>`;
    },
  },
  magnetLabel: {
    render: function (html, args) {
      return html `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 71 37" style="enable-background:new 0 0 71 37;" xml:space="preserve" role="img" aria-labelledby="flagTitle_magnet">
                            <style type="text/css">
                              .st0__magnet{fill:#53575A;}
                              .st1__magnet{fill:#FFFFFF;}
                              .st2__magnet{fill:#8A8C8B;}
                              .st3__magnet{fill:#00A6CE;}
                            </style>
                            <title id="flagTitle_magnet">With Built-In Magnet</title>
                            <g id="flag_magnet__magnet">
                              <g>
                                <path class="st0__magnet" d="M33.7,0.5L32.8,4h-1.2l-0.5-2.2L30.7,4h-1.2l-0.9-3.5h1.1l0.4,2.4l0.6-2.4h1.1l0.5,2.4l0.4-2.4H33.7z"/>
                              </g>
                              <g>
                                <path class="st0__magnet" d="M35.3,0.5V4h-1V0.5H35.3z"/>
                                <path class="st0__magnet" d="M38.7,0.5v0.8h-0.9V4h-1V1.2h-0.9V0.5H38.7z"/>
                              </g>
                              <g>
                                <path class="st0__magnet" d="M42.5,0.5V4h-1V2.6h-1.2V4h-1V0.5h1v1.3h1.2V0.5H42.5z"/>
                              </g>
                            </g>
                            <g>
                              <path class="st0__magnet" d="M33.8,10c0.2,0.3,0.3,0.6,0.3,1c0,0.5-0.2,1-0.6,1.3c-0.4,0.3-0.9,0.5-1.6,0.5h-3.1V6.4h3
                                c0.6,0,1.2,0.1,1.5,0.4C33.8,7.1,34,7.5,34,8c0,0.4-0.1,0.7-0.3,0.9s-0.5,0.4-0.8,0.5C33.3,9.6,33.6,9.7,33.8,10z M30.6,8.9h0.9
                                c0.4,0,0.7-0.2,0.7-0.5c0-0.4-0.2-0.6-0.7-0.6h-0.9V8.9z M32.3,10.8c0-0.2-0.1-0.3-0.2-0.4s-0.3-0.2-0.5-0.2h-1v1.2h1
                                C32.1,11.3,32.3,11.1,32.3,10.8z"/>
                              <path class="st0__magnet" d="M37,6.4v3.7c0,0.3,0.1,0.6,0.2,0.8c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.6-0.1,0.7-0.3c0.2-0.2,0.2-0.5,0.2-0.8
                                V6.4h1.8v3.7c0,0.6-0.1,1.1-0.4,1.5c-0.2,0.4-0.6,0.7-1,0.9s-0.9,0.3-1.4,0.3s-1-0.1-1.4-0.3s-0.7-0.5-1-0.9s-0.3-0.9-0.3-1.5V6.4
                                H37z"/>
                              <path class="st0__magnet" d="M43.8,6.4v6.3h-1.8V6.4H43.8z"/>
                              <path class="st0__magnet" d="M47,11.4h2v1.4h-3.7V6.4H47V11.4z"/>
                              <path class="st0__magnet" d="M54.8,6.4v1.4h-1.7v4.9h-1.8V7.8h-1.7V6.4H54.8z"/>
                              <path class="st0__magnet" d="M59.7,8.9v1.5h-4.1V8.9H59.7z"/>
                              <path class="st0__magnet" d="M63.1,6.4v6.3h-1.8V6.4H63.1z"/>
                              <path class="st0__magnet" d="M70.4,12.7h-1.8l-2.4-3.5v3.5h-1.8V6.4h1.8l2.4,3.6V6.4h1.8V12.7z"/>
                            </g>
                            <g>
                              <path class="st0__magnet" d="M36.3,15.4v6.3h-1.8v-3.5l-1.2,3.5h-1.5l-1.2-3.5v3.5h-1.8v-6.3H31l1.6,4.1l1.6-4.1H36.3z"/>
                              <path class="st0__magnet" d="M41.7,20.7h-2.3l-0.3,1h-1.9l2.3-6.3h2l2.3,6.3H42L41.7,20.7z M41.2,19.4l-0.7-2.1l-0.7,2.1H41.2z"/>
                              <path class="st0__magnet" d="M48.9,17.5c-0.1-0.2-0.2-0.3-0.4-0.4S48.1,17,47.8,17c-0.4,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.2
                                c0,0.5,0.1,1,0.4,1.2s0.7,0.4,1.2,0.4c0.6,0,1.1-0.3,1.3-0.8h-1.8v-1.3h3.3v1.7c-0.1,0.3-0.3,0.7-0.6,0.9c-0.3,0.3-0.6,0.5-1,0.7
                                c-0.4,0.2-0.9,0.3-1.4,0.3c-0.6,0-1.2-0.1-1.7-0.4c-0.5-0.3-0.9-0.7-1.1-1.1s-0.4-1-0.4-1.7c0-0.6,0.1-1.2,0.4-1.7
                                c0.3-0.5,0.6-0.9,1.1-1.1s1-0.4,1.7-0.4c0.8,0,1.5,0.2,2,0.6c0.5,0.4,0.8,0.9,1,1.6H48.9z"/>
                              <path class="st0__magnet" d="M57.9,21.7h-1.8l-2.4-3.5v3.5H52v-6.3h1.8l2.4,3.6v-3.6h1.8V21.7z"/>
                              <path class="st0__magnet" d="M61,16.8v1h2v1.3h-2v1.1h2.3v1.4h-4.1v-6.3h4.1v1.4H61z"/>
                              <path class="st0__magnet" d="M69.3,15.4v1.4h-1.7v4.9h-1.8v-4.9h-1.7v-1.4H69.3z"/>
                            </g>
                            <g>
                              <polygon class="st1__magnet" points="1.3,22.3 6.3,22.1 6.1,19 1.1,19 	"/>
                              <path class="st0__magnet" d="M1.3,22.6c-0.2,0-0.3-0.1-0.3-0.3L0.8,19c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.2-0.1h5
                                c0.2,0,0.3,0.1,0.3,0.3l0.1,3.1c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1L1.3,22.6C1.3,22.6,1.3,22.6,1.3,22.6z M1.5,19.3
                                l0.1,2.6l4.3-0.2l-0.1-2.4H1.5z"/>
                              <polygon class="st1__magnet" points="15.2,19 15,22.1 20.1,22.3 20.2,19 	"/>
                              <path class="st0__magnet" d="M20.1,22.6C20,22.6,20,22.6,20.1,22.6l-5-0.2c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.2l0.1-3.1
                                c0-0.2,0.2-0.3,0.3-0.3h5c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3l-0.2,3.3C20.4,22.5,20.2,22.6,20.1,22.6z M15.4,21.8
                                l4.3,0.2l0.1-2.6h-4.4L15.4,21.8z"/>
                              <path class="st2__magnet" d="M20.6,9.3L20.6,9.3c0-4.7-4.5-8.4-9.9-8.4c-5.5,0-9.9,3.7-9.9,8.3L1.1,19h5L5.8,9.1c0-1.7,2.3-3.2,4.9-3.2
                                c2.6,0,4.9,1.5,4.9,3.2L15.2,19h5L20.6,9.3z"/>
                              <path class="st0__magnet" d="M20.2,19.3h-5c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3l0.4-9.9c0-1.5-2.1-2.8-4.5-2.8
                                c-2.4,0-4.5,1.3-4.5,2.9L6.5,19c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.2,0.1h-5c-0.2,0-0.3-0.1-0.3-0.3L0.4,9.2
                                c0-4.8,4.6-8.6,10.3-8.6s10.3,3.9,10.3,8.6l0,0.1c0,0,0,0,0,0L20.6,19C20.5,19.2,20.4,19.3,20.2,19.3z M15.5,18.7h4.4l0.4-9.5
                                c0-4.4-4.3-7.9-9.6-7.9S1.1,4.8,1.1,9.2l0.4,9.5h4.4L5.4,9.2c0-2,2.4-3.6,5.2-3.6c2.9,0,5.2,1.6,5.2,3.5L15.5,18.7z M20.6,9.3
                                L20.6,9.3L20.6,9.3z"/>
                              <path class="st3__magnet" d="M14.6,29.6h-3.5l1.7-4.4c0.2-0.4-0.4-0.7-0.7-0.4l-5.7,6.4c-0.2,0.3,0,0.7,0.3,0.7h3.5l-1.7,4.4
                                c-0.2,0.4,0.4,0.7,0.7,0.4l5.7-6.4C15.1,30,14.9,29.6,14.6,29.6"/>
                            </g>
                          </svg>`;
    },
  },
  googleLabel: {
    render: function (html, args) {
      return html `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        	 viewBox="0 0 400 124" style="enable-background:new 0 0 400 124;" xml:space="preserve" role="img" aria-labelledby="flagTitle_google">
          <title id="flagTitle_google">Made for Google Pixel</title>
          <style type="text/css">
          	.st2__google{fill:#666C71;}
          	.st3__google{fill:#0081C6;}
          	.st4__google{fill:#00AE57;}
          	.st5__google{fill:#FBAB18;}
          	.st6__google{fill:#F04931;}
          </style>
          <g id="flag_google_google">
            <g id="flag_lockup_google">
                <g>
                    <g>
                        <g>
                            <path class="st2__google" d="M129.25,54.93h-3.51V36.22h3.36v2.6h0.15c0.54-0.92,1.35-1.68,2.46-2.29c1.11-0.61,2.21-0.92,3.3-0.92
                                c1.37,0,2.58,0.32,3.63,0.95s1.81,1.51,2.29,2.63c1.55-2.39,3.7-3.59,6.45-3.59c2.16,0,3.83,0.66,5,1.98
                                c1.17,1.32,1.76,3.21,1.76,5.65v11.68h-3.51V43.78c0-1.76-0.32-3.02-0.96-3.8c-0.64-0.78-1.71-1.16-3.21-1.16
                                c-1.35,0-2.48,0.57-3.4,1.72c-0.92,1.15-1.38,2.5-1.38,4.05v10.35h-3.51V43.78c0-1.76-0.32-3.02-0.95-3.8
                                c-0.64-0.78-1.71-1.16-3.21-1.16c-1.35,0-2.48,0.57-3.4,1.72c-0.92,1.15-1.37,2.5-1.37,4.05V54.93z"/>
                            <path class="st2__google" d="M165.18,35.61c2.6,0,4.64,0.69,6.15,2.08c1.5,1.39,2.25,3.29,2.25,5.71v11.53h-3.36v-2.6h-0.15
                                c-1.45,2.14-3.39,3.21-5.8,3.21c-2.06,0-3.79-0.61-5.17-1.83c-1.39-1.22-2.08-2.75-2.08-4.58c0-1.93,0.73-3.47,2.19-4.62
                                c1.46-1.15,3.42-1.72,5.86-1.72c2.09,0,3.8,0.38,5.15,1.15v-0.8c0-1.22-0.48-2.26-1.45-3.11c-0.97-0.85-2.1-1.28-3.4-1.28
                                c-1.96,0-3.51,0.83-4.66,2.48l-3.09-1.95C159.32,36.83,161.84,35.61,165.18,35.61z M160.64,49.2c0,0.92,0.39,1.68,1.16,2.29
                                c0.78,0.61,1.69,0.92,2.73,0.92c1.47,0,2.79-0.55,3.95-1.64c1.16-1.09,1.74-2.38,1.74-3.86c-1.09-0.87-2.62-1.3-4.58-1.3
                                c-1.43,0-2.62,0.34-3.57,1.03C161.11,47.33,160.64,48.18,160.64,49.2z"/>
                            <path class="st2__google" d="M185.19,55.54c-2.44,0-4.54-0.97-6.3-2.9c-1.73-1.96-2.6-4.31-2.6-7.06c0-2.75,0.87-5.1,2.6-7.06
                                c1.76-1.93,3.86-2.9,6.3-2.9c1.37,0,2.63,0.29,3.76,0.88c1.13,0.59,2.01,1.36,2.62,2.33h0.15l-0.15-2.6v-8.63h3.51v27.34
                                h-3.36v-2.6h-0.15c-0.61,0.97-1.48,1.74-2.62,2.33C187.81,55.24,186.56,55.54,185.19,55.54z M185.76,52.33
                                c1.73,0,3.14-0.62,4.24-1.87c1.14-1.25,1.72-2.88,1.72-4.89c0-1.96-0.57-3.58-1.72-4.85c-1.12-1.27-2.53-1.91-4.24-1.91
                                c-1.68,0-3.09,0.64-4.24,1.91c-1.14,1.27-1.72,2.89-1.72,4.85c0,1.98,0.57,3.6,1.72,4.85
                                C182.67,51.69,184.08,52.33,185.76,52.33z"/>
                            <path class="st2__google" d="M207.56,55.54c-2.75,0-5.02-0.94-6.8-2.83c-1.78-1.88-2.67-4.26-2.67-7.14c0-2.85,0.87-5.22,2.6-7.12
                                c1.73-1.9,3.94-2.84,6.64-2.84c2.77,0,4.98,0.9,6.62,2.69c1.64,1.79,2.46,4.31,2.46,7.54l-0.04,0.38h-14.7
                                c0.05,1.83,0.66,3.31,1.83,4.43c1.17,1.12,2.57,1.68,4.2,1.68c2.24,0,4-1.12,5.27-3.36l3.13,1.53c-0.84,1.58-2,2.81-3.49,3.7
                                C211.13,55.09,209.44,55.54,207.56,55.54z M201.95,43.32h10.73c-0.1-1.3-0.63-2.37-1.58-3.23c-0.96-0.85-2.23-1.28-3.84-1.28
                                c-1.32,0-2.46,0.41-3.42,1.22C202.88,40.85,202.25,41.94,201.95,43.32z"/>
                            <path class="st2__google" d="M235.89,27.28c1.27,0,2.31,0.22,3.13,0.65l-0.95,3.09c-0.61-0.31-1.3-0.46-2.06-0.46
                                c-0.87,0-1.57,0.3-2.12,0.9c-0.55,0.6-0.82,1.39-0.82,2.39v2.37h4.89v3.21h-4.89v15.5h-3.51v-15.5h-3.51v-3.21h3.51v-2.71
                                c0-1.86,0.59-3.36,1.78-4.51C232.51,27.86,234.03,27.28,235.89,27.28z"/>
                            <path class="st2__google" d="M239.09,45.57c0-2.88,0.9-5.26,2.71-7.14c1.83-1.88,4.14-2.83,6.91-2.83c2.77,0,5.06,0.94,6.87,2.83
                                c1.83,1.88,2.75,4.26,2.75,7.14c0,2.9-0.92,5.28-2.75,7.14c-1.81,1.88-4.1,2.83-6.87,2.83c-2.77,0-5.08-0.94-6.91-2.83
                                C239.99,50.83,239.09,48.45,239.09,45.57z M242.6,45.57c0,2.01,0.59,3.64,1.76,4.89c1.17,1.25,2.62,1.87,4.35,1.87
                                c1.73,0,3.18-0.62,4.35-1.87c1.17-1.25,1.76-2.88,1.76-4.89c0-1.99-0.58-3.6-1.76-4.85c-1.2-1.27-2.65-1.91-4.35-1.91
                                s-3.15,0.64-4.35,1.91C243.19,41.97,242.6,43.59,242.6,45.57z"/>
                            <path class="st2__google" d="M264.67,54.93h-3.51V36.22h3.36v3.05h0.15c0.36-0.99,1.09-1.84,2.19-2.54c1.11-0.7,2.2-1.05,3.26-1.05
                                c1.02,0,1.88,0.15,2.6,0.46l-1.07,3.4c-0.43-0.18-1.12-0.27-2.06-0.27c-1.32,0-2.48,0.53-3.46,1.6
                                c-0.98,1.07-1.47,2.32-1.47,3.74V54.93z"/>
                        </g>
                        <g>
                            <path class="st2__google" d="M142.41,92.55h17.64c0.07,0.44,0.13,0.9,0.2,1.39c0.07,0.49,0.1,1,0.1,1.54c0,2.16-0.34,4.3-1.01,6.42
                                c-0.67,2.12-1.82,4.01-3.44,5.66c-1.65,1.72-3.59,3.05-5.81,3.99c-2.22,0.94-4.77,1.42-7.63,1.42c-2.59,0-5.05-0.47-7.35-1.42
                                c-2.31-0.94-4.32-2.26-6.04-3.94c-1.72-1.68-3.08-3.68-4.07-5.99c-0.99-2.31-1.49-4.83-1.49-7.56c0-2.73,0.5-5.25,1.49-7.56
                                c0.99-2.31,2.35-4.3,4.07-5.99c1.72-1.68,3.73-3,6.04-3.94s4.76-1.42,7.35-1.42c2.76,0,5.32,0.49,7.66,1.47
                                c2.34,0.98,4.3,2.34,5.89,4.09l-4,3.99c-1.18-1.31-2.57-2.33-4.17-3.03c-1.6-0.71-3.41-1.06-5.43-1.06
                                c-1.72,0-3.37,0.32-4.95,0.96c-1.58,0.64-2.98,1.54-4.19,2.7c-1.21,1.16-2.17,2.57-2.88,4.22c-0.71,1.65-1.06,3.5-1.06,5.56
                                c0,2.06,0.35,3.91,1.06,5.56c0.71,1.65,1.67,3.06,2.88,4.22c1.21,1.16,2.61,2.06,4.19,2.71s3.25,0.96,5,0.96
                                c2.33,0,4.2-0.35,5.64-1.06c1.43-0.71,2.64-1.53,3.61-2.48c0.71-0.67,1.33-1.56,1.87-2.65c0.54-1.09,0.89-2.3,1.06-3.61
                                h-12.23V92.55z"/>
                            <path class="st2__google" d="M176.65,86.58c1.89,0,3.62,0.33,5.21,0.99c1.58,0.66,2.95,1.58,4.09,2.75c1.14,1.18,2.04,2.58,2.68,4.19
                                c0.64,1.62,0.96,3.37,0.96,5.26c0,1.89-0.32,3.64-0.96,5.26s-1.53,3.02-2.68,4.19c-1.15,1.18-2.51,2.1-4.09,2.76
                                c-1.58,0.66-3.32,0.99-5.21,0.99s-3.62-0.33-5.2-0.99c-1.59-0.66-2.95-1.58-4.1-2.76c-1.14-1.18-2.04-2.58-2.68-4.19
                                s-0.96-3.37-0.96-5.26c0-1.89,0.32-3.64,0.96-5.26c0.64-1.62,1.53-3.01,2.68-4.19c1.15-1.18,2.51-2.1,4.1-2.75
                                C173.02,86.91,174.76,86.58,176.65,86.58z M176.65,107.76c0.94,0,1.85-0.18,2.73-0.56c0.88-0.37,1.66-0.89,2.35-1.57
                                c0.69-0.67,1.24-1.51,1.64-2.5c0.4-0.99,0.6-2.11,0.6-3.36c0-1.25-0.2-2.37-0.6-3.36c-0.41-0.99-0.95-1.83-1.64-2.5
                                c-0.69-0.67-1.47-1.2-2.35-1.57c-0.88-0.37-1.79-0.56-2.73-0.56c-0.94,0-1.85,0.18-2.73,0.56c-0.88,0.37-1.66,0.89-2.35,1.57
                                c-0.69,0.67-1.24,1.51-1.64,2.5c-0.41,0.99-0.61,2.12-0.61,3.36c0,1.25,0.2,2.37,0.61,3.36c0.4,1,0.95,1.83,1.64,2.5
                                c0.69,0.68,1.47,1.2,2.35,1.57C174.79,107.58,175.7,107.76,176.65,107.76z"/>
                            <path class="st2__google" d="M205.19,86.58c1.89,0,3.62,0.33,5.21,0.99c1.58,0.66,2.95,1.58,4.09,2.75c1.14,1.18,2.04,2.58,2.68,4.19
                                c0.64,1.62,0.96,3.37,0.96,5.26c0,1.89-0.32,3.64-0.96,5.26s-1.53,3.02-2.68,4.19c-1.15,1.18-2.51,2.1-4.09,2.76
                                c-1.58,0.66-3.32,0.99-5.21,0.99s-3.62-0.33-5.2-0.99c-1.59-0.66-2.95-1.58-4.1-2.76c-1.14-1.18-2.04-2.58-2.68-4.19
                                s-0.96-3.37-0.96-5.26c0-1.89,0.32-3.64,0.96-5.26c0.64-1.62,1.53-3.01,2.68-4.19c1.15-1.18,2.51-2.1,4.1-2.75
                                C201.57,86.91,203.31,86.58,205.19,86.58z M205.19,107.76c0.94,0,1.85-0.18,2.73-0.56c0.88-0.37,1.66-0.89,2.35-1.57
                                c0.69-0.67,1.24-1.51,1.64-2.5c0.4-0.99,0.6-2.11,0.6-3.36c0-1.25-0.2-2.37-0.6-3.36c-0.41-0.99-0.95-1.83-1.64-2.5
                                c-0.69-0.67-1.47-1.2-2.35-1.57c-0.88-0.37-1.79-0.56-2.73-0.56c-0.94,0-1.85,0.18-2.73,0.56c-0.88,0.37-1.66,0.89-2.35,1.57
                                c-0.69,0.67-1.24,1.51-1.64,2.5c-0.41,0.99-0.61,2.12-0.61,3.36c0,1.25,0.2,2.37,0.61,3.36c0.4,1,0.95,1.83,1.64,2.5
                                c0.69,0.68,1.47,1.2,2.35,1.57C203.34,107.58,204.25,107.76,205.19,107.76z"/>
                            <path class="st2__google" d="M233.56,123.89c-1.72,0-3.24-0.23-4.57-0.68c-1.33-0.46-2.48-1.04-3.46-1.74
                                c-0.98-0.71-1.78-1.5-2.4-2.38c-0.62-0.88-1.09-1.72-1.39-2.53l5.36-2.17c0.47,1.31,1.28,2.38,2.43,3.21
                                c1.14,0.83,2.49,1.24,4.04,1.24c2.33,0,4.14-0.68,5.43-2.04c1.3-1.36,1.95-3.26,1.95-5.7v-2.02h-0.3
                                c-0.78,1.11-1.85,2.04-3.21,2.78c-1.37,0.74-2.96,1.11-4.78,1.11c-1.52,0-2.98-0.32-4.4-0.97s-2.67-1.55-3.77-2.71
                                c-1.09-1.16-1.96-2.55-2.6-4.18c-0.64-1.63-0.96-3.42-0.96-5.36s0.32-3.72,0.96-5.33s1.51-3,2.6-4.16s2.35-2.06,3.77-2.71
                                c1.42-0.64,2.88-0.97,4.4-0.97c1.82,0,3.41,0.37,4.78,1.11c1.36,0.74,2.43,1.67,3.21,2.78h0.3v-3.08h5.41v23.35
                                c0,2.12-0.33,4-0.99,5.64c-0.66,1.63-1.55,3.01-2.68,4.12c-1.13,1.11-2.48,1.96-4.04,2.53
                                C237.07,123.6,235.38,123.89,233.56,123.89z M233.76,107.76c0.91,0,1.8-0.17,2.68-0.51c0.88-0.34,1.64-0.86,2.3-1.54
                                c0.66-0.68,1.19-1.52,1.59-2.52c0.41-0.99,0.61-2.14,0.61-3.44c0-1.27-0.2-2.41-0.61-3.42c-0.4-1.01-0.93-1.85-1.59-2.52
                                c-0.66-0.67-1.42-1.18-2.3-1.54c-0.88-0.36-1.77-0.54-2.68-0.54c-0.94,0-1.84,0.18-2.7,0.54c-0.86,0.36-1.63,0.88-2.3,1.57
                                c-0.67,0.68-1.21,1.52-1.62,2.52c-0.41,0.99-0.61,2.12-0.61,3.39s0.2,2.4,0.61,3.39c0.4,0.99,0.94,1.83,1.62,2.52
                                c0.67,0.68,1.44,1.21,2.3,1.56C231.91,107.59,232.81,107.76,233.76,107.76z"/>
                            <path class="st2__google" d="M251.75,112.16V75.97h5.61v36.19H251.75z"/>
                            <path class="st2__google" d="M285.87,106.25c-1.05,1.92-2.53,3.52-4.45,4.8c-1.92,1.28-4.28,1.92-7.08,1.92
                                c-1.85,0-3.56-0.33-5.13-0.99c-1.57-0.66-2.92-1.58-4.07-2.76c-1.14-1.18-2.04-2.57-2.68-4.17c-0.64-1.6-0.96-3.36-0.96-5.28
                                c0-1.79,0.3-3.48,0.91-5.08c0.61-1.6,1.46-3,2.55-4.2c1.09-1.2,2.42-2.15,3.97-2.85s3.27-1.06,5.16-1.06
                                c1.92,0,3.63,0.32,5.13,0.96c1.5,0.64,2.77,1.53,3.82,2.68c1.04,1.15,1.84,2.53,2.4,4.14c0.56,1.62,0.83,3.39,0.83,5.31
                                c0,0.17,0,0.32,0,0.46c-0.03,0.17-0.05,0.32-0.05,0.45c-0.03,0.13-0.05,0.27-0.05,0.41h-19.06c0.1,1.18,0.39,2.21,0.86,3.08
                                c0.47,0.88,1.05,1.6,1.74,2.17c0.69,0.57,1.46,1,2.3,1.26s1.67,0.4,2.48,0.4c1.62,0,2.95-0.39,3.99-1.16
                                c1.04-0.78,1.9-1.73,2.58-2.88L285.87,106.25z M280.67,96.69c-0.07-0.5-0.23-1.07-0.48-1.69c-0.25-0.62-0.64-1.2-1.16-1.72
                                s-1.2-0.97-2.02-1.34c-0.83-0.37-1.83-0.56-3.01-0.56c-1.62,0-3.01,0.48-4.17,1.44c-1.16,0.96-1.95,2.25-2.35,3.87H280.67z"/>
                            <path class="st2__google" d="M302.45,112.16V75.97h12.53c1.62,0,3.14,0.27,4.57,0.81c1.43,0.54,2.69,1.3,3.77,2.27
                                c1.08,0.98,1.93,2.15,2.55,3.51c0.62,1.37,0.93,2.87,0.93,4.52c0,1.62-0.31,3.11-0.93,4.47c-0.62,1.36-1.47,2.54-2.55,3.51
                                c-1.08,0.98-2.33,1.74-3.77,2.27c-1.43,0.54-2.96,0.81-4.57,0.81h-6.82v14H302.45z M315.14,92.7c0.94,0,1.79-0.16,2.53-0.48
                                c0.74-0.32,1.37-0.75,1.87-1.29c0.51-0.54,0.89-1.14,1.16-1.82c0.27-0.67,0.4-1.35,0.4-2.02c0-0.71-0.13-1.4-0.4-2.07
                                c-0.27-0.67-0.66-1.27-1.16-1.79c-0.5-0.52-1.13-0.95-1.87-1.29c-0.74-0.34-1.58-0.5-2.53-0.5h-6.98V92.7H315.14z"/>
                            <path class="st2__google" d="M333.32,83.15c-1.08,0-1.98-0.37-2.71-1.11s-1.09-1.63-1.09-2.68c0-1.04,0.36-1.94,1.09-2.68
                                s1.63-1.11,2.71-1.11c1.04,0,1.93,0.37,2.65,1.11c0.72,0.74,1.09,1.63,1.09,2.68c0,1.05-0.36,1.94-1.09,2.68
                                C335.24,82.78,334.36,83.15,333.32,83.15z M330.48,112.16V87.39h5.61v24.77H330.48z"/>
                            <path class="st2__google" d="M347.88,99.58l-8.54-12.18h6.52l5.36,7.83h0.15l5-7.83h6.77l-8.64,12.18l8.79,12.59h-6.67l-5.36-8.09
                                h-0.15l-5.31,8.09h-6.62L347.88,99.58z"/>
                            <path class="st2__google" d="M388.22,106.25c-1.05,1.92-2.53,3.52-4.45,4.8c-1.92,1.28-4.28,1.92-7.08,1.92
                                c-1.85,0-3.56-0.33-5.13-0.99c-1.57-0.66-2.92-1.58-4.07-2.76c-1.14-1.18-2.04-2.57-2.68-4.17c-0.64-1.6-0.96-3.36-0.96-5.28
                                c0-1.79,0.3-3.48,0.91-5.08c0.61-1.6,1.46-3,2.55-4.2c1.09-1.2,2.42-2.15,3.97-2.85s3.27-1.06,5.16-1.06
                                c1.92,0,3.63,0.32,5.13,0.96c1.5,0.64,2.77,1.53,3.82,2.68c1.04,1.15,1.84,2.53,2.4,4.14c0.56,1.62,0.83,3.39,0.83,5.31
                                c0,0.17,0,0.32,0,0.46c-0.03,0.17-0.05,0.32-0.05,0.45c-0.03,0.13-0.05,0.27-0.05,0.41h-19.06c0.1,1.18,0.39,2.21,0.86,3.08
                                c0.47,0.88,1.05,1.6,1.74,2.17c0.69,0.57,1.46,1,2.3,1.26s1.67,0.4,2.48,0.4c1.62,0,2.95-0.39,3.99-1.16
                                c1.04-0.78,1.9-1.73,2.58-2.88L388.22,106.25z M383.01,96.69c-0.07-0.5-0.23-1.07-0.48-1.69c-0.25-0.62-0.64-1.2-1.16-1.72
                                s-1.2-0.97-2.02-1.34c-0.83-0.37-1.83-0.56-3.01-0.56c-1.62,0-3.01,0.48-4.17,1.44c-1.16,0.96-1.95,2.25-2.35,3.87H383.01z"/>
                            <path class="st2__google" d="M392.74,112.16V75.97h5.61v36.19H392.74z"/>
                        </g>
                        <g>
                            <g>
                                <path class="st3__google" d="M86.94,74.56c0-3.38-0.34-6.61-0.94-9.69H45.16v17.41l23.35-0.01c-0.98,5.5-4.04,10.18-8.7,13.31v11.01
                                    H74C82.22,99,86.94,87.8,86.94,74.56"/>
                                <path class="st4__google" d="M45.16,117.08c11.74,0,21.63-3.86,28.84-10.5L59.81,95.57c-3.87,2.59-8.84,4.1-14.65,4.1
                                    c-11.29,0-20.87-7.63-24.28-17.9H6.28v11.33C13.44,107.32,28.16,117.08,45.16,117.08"/>
                                <path class="st5__google" d="M20.88,81.78c-0.86-2.6-1.33-5.36-1.33-8.21c0-2.85,0.47-5.62,1.33-8.21V54.03H6.28
                                    C3.32,59.9,1.65,66.54,1.65,73.57c0,7.03,1.68,13.66,4.64,19.54L20.88,81.78z"/>
                                <path class="st6__google" d="M45.16,47.46c6.37,0,12.07,2.19,16.57,6.48l12.54-12.54c-7.54-7.03-17.38-11.34-29.11-11.34
                                    c-17,0-31.72,9.76-38.88,23.97l14.6,11.33C24.29,55.09,33.87,47.46,45.16,47.46"/>
                            </g>
                        </g>
                    </g>
                </g>
              </g>
        	</g>
        </svg>`;
    },
  }
}

// VARIABLES
TagalysCustomizations.variables = {
  MAX_PRODUCT_SUGGESTIONS: 4,
  MAX_TEXT_SUGGESTIONS: 4,
  SEARCH_SUGGESTIONS_INPUT_SELECTOR: ".site-header__search-input",
  SEARCH_SUGGESTIONS_ALIGN_TO_SELECTOR: ".site-header__search-form",
  SEARCH_RESULTS_URL: "/pages/search",
  SEARCH_RESULTS_SELECTOR: ".search-results-container"
}

// SEARCH SUGGESTIONS
TagalysCustomizations.initSearchSuggestions = function () {
  Tagalys.UIWidgets.SearchSuggestions.init(TagalysCustomizations.variables.SEARCH_SUGGESTIONS_INPUT_SELECTOR, {
    searchResultsURL: TagalysCustomizations.variables.SEARCH_RESULTS_URL,
    templates: {
      ...TagalysCustomizations.commonTemplates,
      widget: {
        options: {
          queriesLimit: TagalysCustomizations.variables.MAX_TEXT_SUGGESTIONS,
          productsLimit: TagalysCustomizations.variables.MAX_PRODUCT_SUGGESTIONS,
          alignToSelector: TagalysCustomizations.variables.SEARCH_SUGGESTIONS_ALIGN_TO_SELECTOR,
          includeTagalysCSS: ["layout"]
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var width = helpers.getTargetNodeWidth()
          var style = props.inheritAlignmentElementWidth ? { width: width } : {}
          return html`
            <div ref=${props.tagalysSearchSuggestionsPopoverRef} style=${style} class="search-suggestions">
              <div class="container">
                ${helpers.exceedsMinimumCharactersToShowSuggestions()
                  ? html` <${args.templates.typeSuggestions} /> `
                  : null
                }
              </div>
            </div>
          `;
        }
      },
      clickSuggestions: {
        render: function (html, args) {
          var helpers = args.props.helpers
          var recentAndPopularSearches = helpers.getRecentAndPopularSearches()
          var hasRecentSearches = recentAndPopularSearches.recentSearches.length > 0
          var hasPopularSearches = recentAndPopularSearches.popularSearches.length > 0
          return html`
            ${hasRecentSearches ? html `<p class="h6 click-suggestions-label suggestions-label">Recent searches:</p>` : null}
            <ul class="click-suggestions">
              ${recentAndPopularSearches.recentSearches.map(
                recentSearch =>
                  html`
                    <${args.templates.recentSearchItem} recentSearch=${recentSearch} />
                  `
              )}
            ${hasPopularSearches ? html `<p class="h6 click-suggestions-label suggestions-label">Popular searches:</p>`  : null}
            ${recentAndPopularSearches.popularSearches.map(
              popularSearch =>
                html`
                  <${args.templates.popularSearchItem} popularSearch=${popularSearch} />
                `
            )}
            </ul>
          `;
        }
      },
      typeSuggestions: {
        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers
          var textSuggestions = helpers.getTextSuggestions()
          var products = helpers.getProducts()
          var classes = ["type-suggestions"]
          if (helpers.hasTextSearchSuggestions() > 0) {
            classes.push("product-and-text-suggestions")
          } else {
            classes.push("product-suggestions")
          }
          var className = classes.join(" ")

          return html`
            <div class=${className}>
              <${args.templates.products}
                class="product-suggestions"
              />
              ${helpers.hasTextSearchSuggestions() ?
                html`
                  <div class="text-suggestions-container">
                    <p class="h6 suggestions-label">Recommended Searches:</p>
                    <ul class="text-suggestions">
                      ${textSuggestions.map(
                        textSuggestion =>
                          html`
                            <${args.templates.textSuggestionItem} textSuggestion=${textSuggestion} />
                          `
                      )}
                    </ul>
                  </div>
                `: null
              }
            </div>
            ${products.length > 0 ? html`
              <div class="view-more">
                <button class="btn btn-small" onClick=${function () {
                  helpers.onSearchSubmit(helpers.getEnteredSearchQuery())
                }}> View more </button>
              </div>
              ` :
              null
            }
        `;
        }
      },
      products: {
        callbacks: {
          afterEveryRender: function(helpers) {
            TagalysCustomizations.utilities.initProductRatings(helpers, {
              baseSelector: ".search-suggestions",
              widgetContext: "search-suggestions"
            })
          }
        }
      },
      product: {
        render: function (html, args) {
          return TagalysCustomizations.utilities.productRenderer(html, args, {
            query: args.props.helpers.getEnteredSearchQuery(),
            namespace: ".search-suggestions",
            widgetContext: "search-suggestions"
          })
        }
      },
    },
  });
}
// SEARCH
TagalysCustomizations.initSearchResults = function(showReviews, showSwatches, showProdFitment) {
  let show_reviews = showReviews;
  let show_swatches = showSwatches;
  let show_pfitment = showProdFitment;
  
  Tagalys.UIWidgets.SearchResults.init(TagalysCustomizations.variables.SEARCH_RESULTS_SELECTOR, {
    templates: {
      ...TagalysCustomizations.commonTemplates,
      loader: {
        render: function (html, args) {
          return html `
            <div class="loading" style="">
              <span class="loading-icon"></span>
            </div>
          `
        }
      },
      widget: {
        labels: {
          searchResults: {
            heading: {
              standard: `Search results for “{{searchTerm}}”`,
            },
            noResultsHeading: "Sorry! No Products Found. But you may like..."
          },
          filters: {
            heading: "FILTER",
            clearAllFilters: 'Clear All'
          },
        },
        options: {
          includeTagalysCSS: ["layout"]
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          if (helpers.isInitialLoading()) {
            return html`<div class="plp search-results"> <${args.templates.loader} /> </div>`;
          }

          let classes = ["plp", "search-results"];
          if (helpers.isFilterDrawerOpen()) {
            classes.push("filter-drawer-opened");
          }

          if (helpers.canShowFiltersInDrawer()) {
            classes.push("show-filters-in-drawer");
          }

          var className = classes.join(" ");

          if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
            return html`
              <div class="plp search-results">
                <${args.templates.noResults} />
              </div>
            `;
          }

          return html`
            <div class=${className}>
              <${args.templates.header} />
              ${helpers.isLoading() ? html` <${args.templates.loader} />
              ` : null}
              ${helpers.isFilterDrawerOpen() ? html` <div class="filter-overlay" onclick=${helpers.closeFilterDrawer}/>` : null}
              <div class="filters-and-products-list">
                <${args.templates.filters} />
                <div class="products-list">
                  <${args.templates.productListHeader} />
                  <${args.templates.products} />
                  <${args.templates.productListFooter} />
                </div>
              </div>
              <${args.templates.footer} />
            </div>
          `;
        }
      },
      infoAndActions: {
        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers
          var labels = args.labels
          var filterOptions = helpers.getTemplateOptions('filters')

          var getResultsLabel = () => {
            return labels.searchResults.productsCount.replace("{{productsCount}}", helpers.getTotalProductsCount())
          }

          return html`
            <div class="plp-info-and-actions">
              <div class="results-count-and-filter-toggle">
                <strong class="results-count">${getResultsLabel()}</strong>
                <button
                  onclick=${helpers.openFilterDrawer}
                  class="filter-drawer-toggle"
                >
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-filter" viewBox="0 0 64 64"><path d="M48 42h10M48 42a5 5 0 1 1-5-5 5 5 0 0 1 5 5zM7 42h31M16 22H6M16 22a5 5 0 1 1 5 5 5 5 0 0 1-5-5zM57 22H26"></path></svg>
                  ${labels.filters.drawerFilterToggle}
                </button>
              </div>
              ${filterOptions.includeSortOptionsInFilters ? null : html` <${args.templates.sortOptions} /> `}
            </div>
          `;
        },
      },
      sortOptions: {
        render: function (html, args) {
          var props = args.props;
          var labels = args.labels;
          var helpers = props.helpers;
          var sortOptions = helpers.getSortOptions();
          var appliedSortOption = helpers.getAppliedSortOption();

          var applySortOption = (event) => {
            helpers.applySortOption(event.target.value);
          };

          return html`
            <div class="sort-options-container">
              <select
                class="sort-options"
                value=${appliedSortOption.id}
                onchange=${applySortOption}
              >
                ${sortOptions.map((sortOption) => {
                  return html`
                    <option value=${sortOption.id}>${sortOption.label}</option>
                  `;
                })}
              </select>
            </div>
          `;
        },
      },
      product: {
        render: function (html, args) {
          return TagalysCustomizations.utilities.productRenderer(html, args, {
            query: args.props.helpers.getQuery(),
            namespace: ".search-results-container",
            widgetContext: "search-results",
            showReviews: show_reviews,
            showSwatches: show_swatches,
            showProdFitment: show_pfitment
          })
        }
      },
      checkboxFilterItem: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          const onFilterClick = (event) => {
            event.stopPropagation();
            if (props.filterItem.selected) {
              helpers.clearFilter(props.filterId, props.filterItem.id);
            } else {
              helpers.applyFilter(props.filterId, props.filterItem.id);
            }
          };

          return html`
            <li
              class="filter-item${props.filterItem.selected ? " selected" : ""}"
              data-filter-item-id=${props.filterItem.id}
              onClick=${onFilterClick}
            >
              <button class="filter-checkbox-and-label" role="checkbox" aria-checked="${props.filterItem.selected}">
                <span class="checkbox"></span>
                <span class="filter-item-label">${props.filterItem.name}</span>
                ${props.showMatchingProductsCount
                  ? html`
                      <span
                        class="filter-item-count"
                        aria-label=${`Number of products: (${props.filterItem.count})`}
                      >
                          (${props.filterItem.count})
                      </span>
                    `
                  : null}
              </button>
              ${props.children}
            </li>
          `;
        },
      },
      filterHeader: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels;
          var filterOptions = helpers.getTemplateOptions("filters");
          var showClearActionForIndividualFilters =
            filterOptions.showClearActionForIndividualFilters &&
            helpers.isFilterApplied(props.filterId);
          var toggleCollapsibleFilter = () => {
            helpers.toggleCollapsibleFilter(props.filterId);
          };
          var clearFilter = (event) => {
            event.stopPropagation();
            helpers.clearFilter(props.filterId);
          };
          return html`
            <div
              onClick=${filterOptions.collapsible
                ? toggleCollapsibleFilter
                : undefined}
              class="filter-header"
            >
              <button aria-controls=${`filter-set-${props.filterId}`} aria-label=${`Filter by ${props.filterHeading}`} tabindex="0" aria-expanded="${props.collapseState}">
                <span class="filter-heading">${props.filterHeading}</span>
              </button>              
              <div class="filter-actions">
                <span class="filter-action-toggle-collapse">
                  ${filterOptions.collapsible
                    ? html` <${args.templates.downArrow} /> `
                    : null}
                </span>
              </div>
            </div>
            ${showClearActionForIndividualFilters
              ? html`
                  <button onClick=${clearFilter} class="filter-action-clear" aria-label=${`Clear filter by ${props.filterHeading}`}>
                    ${labels.filters.clearIndividualFilter}
                  </button>
                `
              : null}
          `;
        },
      },
      filtersHeader: {
        render: function (html, args) {
          var props = args.props;
          var labels = args.labels;
          var helpers = props.helpers;
          var appliedFilters = helpers.getAppliedFilters(true);
          var showClearAllFiltersAction = appliedFilters.length;

          return html`
            <div class="filters-header">
              <div class="filters-heading-and-close-action">
                <span class="filters-heading">${labels.filters.heading}</span>
                <${args.templates.closeIcon}
                  onClick=${props.helpers.closeFilterDrawer}
                />
              </div>
              <div class="sub-header">
                ${props.helpers.getAppliedFilters().length > 0
                  ? html`<span class="refine-by-heading"
                      >REFINE BY</span
                    >`
                  : null}
                ${showClearAllFiltersAction
                  ? html`
                      <button
                        class="clear-all-filters"
                        aria-label="Clear all filters"
                        onclick=${helpers.clearAllFilters}
                      >
                        ${labels.filters.clearAllFilters}
                      </button>
                    `
                  : null}
              </div>
            </div>
          `;
        },
      },
      rangeSliderFilterItem: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels

          return html`
            <div class="range-slider filter-item">
              <div class="input-group">
                <div class="input-container">
                  <input
                    type="number"
                    value=${props.sliderInputValues[0]}
                    onblur=${props.onInputBlur}
                    onchange=${props.onMinChange}
                  />
                </div>
                <span class="to"> - </span>
                <div class="input-container">
                  <input
                    type="number"
                    value=${props.sliderInputValues[1]}
                    onblur=${props.onInputBlur}
                    onchange=${props.onMaxChange}
                  />
                </div>
              </div>
              <div ref=${props.sliderRef} />
            </div>
          `;
        },
      },
      filter: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers
          var classes = ["filter"]
          var isCollapseOpen = false
          if(props.collapsible){
            isCollapseOpen = helpers.isCollapsibleFilterExpanded(props.filter.id);
            isCollapseOpen ? classes.push("expanded") : classes.push("collapsed");
          }
          var className = classes.join(" ")
          return html`
            <div class=${className} data-filter-id=${props.filter.id}>
              <${args.templates.filterHeader}
                filterHeading=${props.filter.name}
                filterId=${props.filter.id}
                collapseState=${isCollapseOpen}
              />
              <${args.templates.filterItems}
                filter=${props.filter}
                filterId=${props.filter.id}
                filterHeading=${props.filter.name}
              />
            </div>
          `;
        }
      },
      filters: {
        options: {
          autoCollapse: true,
          expandTopNFiltersByDefault: 1
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var filters = helpers.getFilters();
          var classes = ["filters"];
          if (props.collapsible) {
            classes.push("collapsible");
          }

          var className = classes.join(" ");
          return html`
            <div class=${className}>
              <${args.templates.filtersHeader} />
              ${props.showAppliedFilters
                ? html` <${args.templates.appliedFilters} /> `
                : null}
              ${props.includeSortOptionsInFilters === "top"
                ? html` <${args.templates.sortOptionInFilters} /> `
                : null}
                <div class="filters-container">
                  ${filters.map(
                    (filter) => html`<${args.templates.filter} filter=${filter} />`
                  )}
                  ${props.includeSortOptionsInFilters === true ||
                  props.includeSortOptionsInFilters === "bottom"
                    ? html` <${args.templates.sortOptionInFilters} /> `
                    : null}
                </div>
            </div>
          `;
        },
      },
      filterCheckBoxes: {
      render: function (html, args) {
        var props = args.props;
        return html`
          <fieldset>
            <legend class="sr-only">${props.filterHeading}</legend>
            <ul class="filter-checkboxes">
            ${props.filterItems.map(filterItem => {
              return html`
                  <${args.templates.checkboxFilterItem}
                  filterId=${props.filterId}
                  filterItem=${filterItem}
                >
                ${filterItem.selected && filterItem.items
                  ? html`
                        <${args.templates.filterCheckBoxes}
                        filterId=${props.filterId}
                        filterItems=${filterItem.items}
                      />
                    `
                  : null
                }
                </${args.templates.checkboxFilterItem}>
            `;
            })}
            </ul>
          </fieldset>
        `;
        }
      },
      filterItems: {
        render: function (html, args) {
          var props = args.props;
          if (props.filter.type === "checkbox") {
            return html`
              <div class="filter-body filter-body-checkboxes" id=${`filter-set-${props.filterId}`}>
                <${args.templates.filterCheckBoxes}
                  filterId=${props.filter.id}
                  filterItems=${props.filter.items}
                  filterHeading=${props.filter.name}
                />
              </div>
            `;
          }
          return html`
            <div class="filter-body filter-body-range">
              <${args.templates.rangeSliderFilterItem} filter=${props.filter} />
            </div>
          `
        },
      },
      appliedFilters: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var appliedFilters = helpers.getAppliedFilters(true);
          if (!appliedFilters.length) return null;
          return html`
            <ul class="applied-filters">
              ${appliedFilters.map((appliedFilter) => {
                var filter = props.helpers.getFilterById(appliedFilter.id);
                if (appliedFilter.type === "range") {
                  return html`
                    <li
                      onClick=${() => helpers.clearFilter(appliedFilter.id)}
                      class="applied-filter"
                      aria-label=${`Clear filter by ${filter.name}`}
                    >
                      <span class="applied-filter-label">
                        <span>
                           <span class="applied-filter-name">
                            ${filter.name}:
                          </span>
                          <span class="applied-filter-item-name">
                            ${helpers.labelFormatter(
                              appliedFilter.display_format,
                              appliedFilter.selected_min,
                              appliedFilter.currency
                            )}
                            ${" "}
                            -
                            ${" "}
                            ${helpers.labelFormatter(
                              appliedFilter.display_format,
                              appliedFilter.selected_max,
                              appliedFilter.currency
                            )}
                          </span>
                        </span>
                      </span>
                      <span class="applied-filter-action-clear">
                        <${args.templates.closeIcon} />
                      </span>
                    </li>
                  `;
                }
                return appliedFilter.items.map((filterItem) => {
                  return html`
                    <li
                      class="applied-filter"
                      onClick=${() =>
                        helpers.clearFilter(appliedFilter.id, filterItem.id)}
                      aria-label=${`Clear filter by ${filter.name}`}
                    >
                      <span class="applied-filter-label">
                        <span>
                          <span class="applied-filter-name">
                            ${filter.name}:
                          </span>
                          <span class="applied-filter-item-name">
                            ${filterItem.name}
                          </span>
                        </span>
                        <span class="applied-filter-action-clear">
                          <${args.templates.closeIcon} />
                        </span>
                      </span>
                    </li>
                  `;
                });
              })}
            </ul>
          `;
        },
      },
      paginationLinks: {
        options: {
          showNumberedPageLinks: true,
          numberedPageLinksWindowSize: 2,
          showPreviousPageLink: true,
          showFirstPageLink: false,
          showNextPageLink: true,
          scrollTop: true
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels;
          var pagesToDisplay = helpers.getPagesToDisplay(
            props.numberedPageLinksWindowSize
          );
          var currentPage = helpers.getCurrentPage();
          var hasNextPage = helpers.hasNextPage();

          // append last page
          var apiResponse = helpers.getAPIResponse()
          var totalPages = apiResponse.total_pages
          var totalResults = apiResponse.total
          if (totalResults <= 1000) {
            pagesToDisplay = TagalysCustomizations.utilities.getPagesToDisplay(currentPage,totalPages,props.numberedPageLinksWindowSize)
          }

          return html`
            <div class="pagination">
              ${(props.showPreviousPageLink)
                ? html`
                    <button
                      class=${`btn${currentPage === 1 ? " disabled previous" : " previous"}`}
                      onclick=${currentPage === 1
                        ? undefined
                        : helpers.goToPreviousPage}
                    >
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg>
                    </button>
                  `
                : null}
              ${props.showNumberedPageLinks
                ? pagesToDisplay.map((pageDetail, index) => {
                    var classes = ["btn"];
                    var showEllipsis = pageDetail.jumpAfter;
                    if (pageDetail.current) classes.push("active");
                    if (pageDetail.jumpAfter) classes.push("page-jump-over");
                    var className = classes.join(" ");
                    return html`
                      <button
                        key=${index}
                        class=${`${className}`}
                        onclick=${() => {
                          !showEllipsis && helpers.goToPage(pageDetail.page);
                        }}
                      >
                        ${showEllipsis ? "..." : pageDetail.page}
                      </button>
                    `;
                  })
                : null}
              ${(props.showNextPageLink)
                ? html`
                    <button
                      class=${`btn${!hasNextPage ? " disabled next" : " next"}`}
                      onclick=${hasNextPage ? helpers.goToNextPage : undefined}
                    >
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>
                    </button>
                  `
                : null}
            </div>
          `;
        },
      },
      products: {
        callbacks: {
          afterEveryRender: function(helpers) {
            TagalysCustomizations.utilities.initProductRatings(helpers, {
              baseSelector: ".search-results-container",
              widgetContext: "search-results"
            })
          }
        }
      },
      noResults: {
        options: {
          widgets: [{
            widgetId: "2ef0142b50f3763431aa",
            options: {
              templates: {
                ...TagalysCustomizations.commonTemplates,
                products: {
                  callbacks: {
                    afterEveryRender: function(helpers) {
                      TagalysCustomizations.utilities.initProductRatings(helpers, {
                        baseSelector: ".no-results",
                        widgetContext: "no-results"
                      })
                    }
                  }
                },
                product: {
                  render: function (html, args) {
                    return TagalysCustomizations.utilities.productRenderer(html, args, {
                      query: "",
                      namespace: ".no-results",
                      widgetContext: "no-results"
                    })
                  }
                }
              }
            }
          }]
        }
      }
    },
  });
}